import React, { useCallback, useEffect, useRef, useState } from 'react';
import { documentCfValue } from '../utils/codiceFiscale';
import {
    DialogTitle,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Dialog,
    IconButton,
    TextField,
    Typography,
    Grid,
    Autocomplete,
    FormControlLabel,
    Checkbox,
    Box,
    ButtonGroup,
    LinearProgress,
    CircularProgress,
    Alert,
} from '@mui/material';
import {
    Add,
    Close,
    ArrowForward,
    ArrowBack,
    Print,
    Check,
    ArrowDropUp,
    Delete,
    Edit,
    FolderShared,
    Email,
    Circle,
    Person,
    Send,
    Upload,
} from '@mui/icons-material';
import {
    DataGridPro,
    itIT,
    GridToolbarContainer,
    GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';
import { CustomFooterPersonalized } from '../utils/CustomFooterPersonalized';
import {
    LocalizationProvider,
    DatePicker,
    TimePicker,
} from '@mui/x-date-pickers';
import { AdapterMoment as DateAdapter } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import unsplash from '../api/unsplash';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import GlobalSnackbar from './Snackbar';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import Grow from '@mui/material/Grow';
import Zoom from '@mui/material/Zoom';
import EditIcon from '@mui/icons-material/Edit';
import GroupsIcon from '@mui/icons-material/Groups';
import PrintIcon from '@mui/icons-material/Print';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuList from '@mui/material/MenuList';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { NewFromatori } from './Formatori';
import AddAllegatiInput from './AddAllegatiInput';
import { BulkAttestatiImportDialog } from './CorsiCliente';
import { getAttestatoPeriod } from '../utils/attestatoPeriod';

var QRCode = require('qrcode');

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const DettaglioCorsi = (props) => {
    const [open, setOpen] = useState(false);
    const [formatore, setFormatore] = useState(null);
    const [codiceCorso, setCodiceCorso] = useState(null);
    const [modalita, setModalita] = useState(null);
    const [value, setValue] = useState(0);
    const [operation, setOperation] = useState('');

    const [openButton, setOpenButton] = useState(false);
    const [openButtonReport, setOpenButtonReport] = useState(false);
    const anchorRef = useRef(null);
    const selectedIndex = 1;
    const [postiRimanenti, setPostiRimanenti] = useState(0);

    const [openReport, setOpenReport] = useState(false);
    const [openPartecipanti, setOpenPartecipanti] = useState(false);
    const [openBulkImport, setOpenBulkImport] = useState(false);
    const [bulkImportClienteId, setBulkImportClienteId] = useState(null);
    const anchorRefReport = useRef(null);
    const selectedIndexReport = 1;
    const [hideDialog, setHideDialog] = useState(false);

    const [corsoH, setCorsoH] = useState({
        Tipo: null,
        NomeEdizione: '',
        Modalita: null,
        Descrizione: '',
        NomeFormatore: '',
        ModalitaFatturazione: null,
        CostoForfait: null,
        Formatore: null,
        Luogo: '',
        Aggiornamento: 0,
        Note: '',
        Visibile: 0,
        PostiTotali: 0,
    });
    const [corsiR, setCorsiR] = useState([]);
    const [loading, setLoading] = useState(true);
    const [corsiPresenze, setCorsiPresenze] = useState([]);
    const [loadingPres, setLoadingPres] = useState(true);
    const [updated, setUpdated] = useState(false);
    const [idCorso, setIdCorso] = useState(null);
    const [giornoSel, setGiornoSel] = useState(null);
    const [selectedPresenzeIds, setSelectedPresenzeIds] = useState([]);
    const [clienti, setClienti] = useState([]);
    const giornoCorso = useRef(0);
    const [corsiAttestati, setCorsiAttestati] = useState([
        {
            Attestato1: '',
            Attestato2: '',
            Attestato3: '',
        },
    ]);
    const [stampa, setStampa] = useState(true);

    const [expanded, setExpanded] = useState(false);
    const [missingEmail, setMissingEmail] = useState([]);
    const [files, setFiles] = useState([]);
    const [sharedFileNames, setSharedFileNames] = useState([]);
    const [certProgress, setCertProgress] = useState({ current: 0, total: 0 });
    const logoCacheRef = useRef(new Map());
    const lastPresenzeGridInteractionRef = useRef(null);
    const presenzeSnapshotRef = useRef([]);
    const [presenzeDirty, setPresenzeDirty] = useState(false);
    const [savingPresenze, setSavingPresenze] = useState(false);
    const currentPresenzeRows = corsiPresenze?.[value] || [];
    const allCurrentRowsPresent =
        currentPresenzeRows.length > 0 &&
        currentPresenzeRows.every((row) => row.presenza === 1);
    const bulkPresenceTarget = allCurrentRowsPresent ? 0 : 1;
    const bulkPresenceLabel =
        bulkPresenceTarget === 1
            ? 'Segna tutti presenti'
            : 'Segna tutti assenti';
    const filterPrintablePresenze = (rows = []) => {
        if (corsoH.Modalita === 2) {
            return rows.filter((row) => row.perc_course === 100);
        }
        return rows.filter((row) => row.presenza === 1);
    };
    const isPrintablePresenza = (row) =>
        filterPrintablePresenze([row]).length > 0;
    const syncAttestatiSelection = (ids, rows = currentPresenzeRows) => {
        const normalizedIds = ids.map((id) => Number(id));
        const selectedIDs = new Set(normalizedIds);
        const selectedRowData = (rows || []).filter((row) =>
            selectedIDs.has(Number(row.ID))
        );
        const printableRows = filterPrintablePresenze(selectedRowData);
        const printableIds = printableRows.map((row) => row.ID);
        setSelectedPresenzeIds(printableIds);
        setStampa(printableRows.length > 0);
    };
    const toggleSelectedPresenzaId = (rowId, rows = currentPresenzeRows) => {
        const normalizedRowId = Number(rowId);
        const row = (rows || []).find(
            (currentRow) => Number(currentRow.ID) === normalizedRowId
        );

        if (!row || !isPrintablePresenza(row)) {
            return;
        }

        const nextIds = selectedPresenzeIds.includes(normalizedRowId)
            ? selectedPresenzeIds.filter(
                  (id) => Number(id) !== normalizedRowId
              )
            : [...selectedPresenzeIds, normalizedRowId];

        syncAttestatiSelection(nextIds, rows);
    };

    const logPresenzeGridInteraction = (type, payload = {}) => {
        const snapshot = {
            type,
            payload,
            timestamp: new Date().toISOString(),
            corsoId: idCorso,
            giornoIndex: value,
            giornoLabel: giornoCorso.current,
            modalita: corsoH?.Modalita,
            selectedPresenzeIds,
            currentRowIds: currentPresenzeRows.map((row) => Number(row.ID)),
            printableRowIds: filterPrintablePresenze(currentPresenzeRows).map(
                (row) => Number(row.ID)
            ),
        };

        lastPresenzeGridInteractionRef.current = snapshot;
        console.debug('Presenze grid interaction', snapshot);
    };

    const handleSaveNuovoFormatore = async (nuovoFormatore, _operazione) => {
        await unsplash.post(
            'formatori',
            { formatore: nuovoFormatore },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            }
        );

        await props.reloadFormatori();
    };

    const options = [
        {
            icon: <ContentCopyIcon />,
            text: 'ATTESTATI MASSIVI',
        },
        {
            icon: <FormatListBulletedIcon />,
            text: 'REGISTRO CONSEGNE',
        },
        {
            icon: <GroupsIcon />,
            text: 'REGISTRO PRESENZE',
        },
        {
            icon: <FolderShared />,
            text: 'STAMPA E ASSOCIA ',
        },
    ];

    const optionsReport = [
        {
            icon: <GroupsIcon />,
            text: 'DIPENDENTI',
            ind: 4,
        },
        {
            icon: <Person />,
            text: 'REFERENTI',
            ind: 5,
        },
    ];

    const clonePresenzeRows = (rows) =>
        Array.isArray(rows)
            ? rows.map((giornoRows) =>
                  Array.isArray(giornoRows)
                      ? giornoRows.map((row) => ({ ...row }))
                      : []
              )
            : [];

    const columns = [
        {
            field: 'Nome',
            headerName: 'Nome',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Cognome',
            headerName: 'Cognome',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'RagioneSociale',
            headerName: 'Ragione Sociale',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'presenza',
            headerName: 'Presenza',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return (
                    <Checkbox
                        checked={params.row.presenza === 1}
                        onClick={(event) => event.stopPropagation()}
                        onMouseDown={(event) => event.stopPropagation()}
                        onKeyDown={(event) => event.stopPropagation()}
                        onChange={(e) => handleClickCheckBox(e, params.row)}
                    ></Checkbox>
                );
            },
        },
    ];

    const columnsOre = [
        {
            field: 'Actions',
            filterable: false,
            headerName: 'Azioni',
            width: 150,
            headerAlign: 'center',
            align: 'center',

            renderCell: (
                params //mi aiuta a mettere il valore
            ) => (
                <>
                    {corsoH?.Modalita !== 2 && (
                        <IconButton
                            aria-label="people"
                            onClick={async () => {
                                setHideDialog(true);
                                setOpenPartecipanti(true);
                                setStampa(false);
                                giornoCorso.current = moment(
                                    params.row.Data
                                ).format('DD/MM/YYYY');
                            }}
                        >
                            <PeopleAltIcon
                                style={{
                                    height: '2rem',
                                    width: '2rem',
                                    color: '#2265B1',
                                }}
                            />
                        </IconButton>
                    )}

                    <DialogGestioneDateCorsi
                        giornoSel={[params.row]}
                        Title="Modifica Giornata"
                        operation="Edit"
                        idCorso={idCorso}
                        formatore={formatore?.ID}
                        handleLoadRighe={handleLoadRighe}
                        snack={props.snack}
                        openSnack={props.openSnack}
                        handleCloseSnack={props.handleCloseSnack}
                        setSnack={props.setSnack}
                        setOpenSnack={props.setOpenSnack}
                    />

                    <DialogDeleteData
                        giornoSel={[params.row]}
                        idCorso={idCorso}
                        handleLoadRighe={handleLoadRighe}
                        snack={props.snack}
                        openSnack={props.openSnack}
                        handleCloseSnack={props.handleCloseSnack}
                        setSnack={props.setSnack}
                        setOpenSnack={props.setOpenSnack}
                    />
                </>
            ),
        },
        {
            field: 'Data',
            headerName: 'Data',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                return (
                    <>
                        {params.row.Data
                            ? moment(params.row.Data).format('DD/MM/YYYY')
                            : ''}
                    </>
                );
            },
        },
        {
            field: 'Ora',
            headerName: 'Ora',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'Durata',
            headerName: 'Durata',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
    ];

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const apiBaseUrl =
        process.env.REACT_APP_API_BASE_URL ||
        'https://api.astm.koala-hse.it/api/';
    const filesBaseUrl = apiBaseUrl.replace(/\/api\/?$/, '/');

    const blobToDataUrl = (blob) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

    const openPdf = (doc, filename) => {
        try {
            const blob = doc.output('blob');
            const blobUrl = URL.createObjectURL(blob);
            const win = window.open(blobUrl, '_blank');
            if (!win) {
                doc.save(filename);
            } else {
                // keep the window reference alive until it finishes loading
                setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
            }
        } catch (error) {
            console.error('Errore apertura PDF', error);
            try {
                doc.save(filename);
            } catch (e) {
                console.error('Fallback apertura PDF fallita', e);
            }
        }
    };

    const startCertProgress = (total) => {
        setCertProgress({ current: 0, total });
    };

    const updateCertProgress = (current, total) => {
        setCertProgress({ current, total });
    };

    const endCertProgress = () => {
        setCertProgress({ current: 0, total: 0 });
    };

    const yieldToUi = () => new Promise((resolve) => setTimeout(resolve, 0));

    const sanitizeFilename = (value) =>
        value
            .toLowerCase()
            .replace(/[^a-z0-9]+/gi, '-')
            .replace(/^-+|-+$/g, '')
            .replace(/--+/g, '-');

    const buildCourseDate = () => {
        const start =
            props.corsoH?.DataInizio || (corsiR.length > 0 ? corsiR[0].Data : '');
        return start ? moment(start).format('YYYY-MM-DD') : 'senzadata';
    };

    const buildAttestatiFilename = () => {
        const descrizione = props.corsoH?.Descrizione || corsoH?.Descrizione || 'corso';
        const slug = sanitizeFilename(descrizione || 'corso');
        const datePart = buildCourseDate();
        return `attestati_${slug}_${datePart}.pdf`;
    };

    const buildLogoDataUrl = (rawLogo) => {
        if (!rawLogo) return undefined;
        const logoTrimmed = rawLogo.trim();
        if (!logoTrimmed) return undefined;
        if (logoTrimmed.startsWith('data:image/')) return logoTrimmed;
        if (logoTrimmed.startsWith('http://') || logoTrimmed.startsWith('https://')) {
            return logoTrimmed;
        }

        const isJpeg = logoTrimmed.startsWith('/9j');
        const isPng = logoTrimmed.startsWith('iVBOR');
        const mime = isJpeg ? 'image/jpeg' : isPng ? 'image/png' : 'image/png';
        if (isJpeg || isPng) {
            return `data:${mime};base64,${logoTrimmed}`;
        }

        const cleanedPath = logoTrimmed.replace(/^\.?\//, '');
        return `${filesBaseUrl}${cleanedPath}`;
    };

    const loadLogoForPdf = async (rawLogo) => {
        const logoSrc = buildLogoDataUrl(rawLogo);
        if (!logoSrc) return { logo: undefined, format: 'PNG' };

        if (logoSrc.startsWith('data:image/')) {
            const format = logoSrc.includes('image/jpeg') || logoSrc.includes('image/jpg') ? 'JPEG' : 'PNG';
            return { logo: logoSrc, format };
        }

        try {
            const shouldSendAuthHeader =
                logoSrc.startsWith(filesBaseUrl) || logoSrc.startsWith(apiBaseUrl);
            const response = await fetch(logoSrc, {
                credentials: 'include',
                headers: shouldSendAuthHeader
                    ? { Authorization: `Bearer ${localStorage.getItem('jwt')}` }
                    : {},
            });
            if (!response.ok) throw new Error('Impossibile recuperare il logo');
            const blob = await response.blob();
            const dataUrl = await blobToDataUrl(blob);
            const format =
                blob.type === 'image/jpeg' || blob.type === 'image/jpg'
                    ? 'JPEG'
                    : 'PNG';
            return { logo: dataUrl, format };
        } catch (error) {
            console.error('Errore caricamento logo attestato', error);
            return { logo: undefined, format: 'PNG' };
        }
    };

    const getLogo = async (clienteId) => {
        if (logoCacheRef.current.has(clienteId)) {
            return logoCacheRef.current.get(clienteId);
        }
        try {
            const response = await unsplash.get(`clienti/${clienteId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                params: { id: clienteId },
            });
            const cliente = response.data.data;
            const rawLogo = cliente?.Logo ?? '';
            const { logo, format } = rawLogo ? await loadLogoForPdf(rawLogo) : { logo: undefined, format: 'PNG' };
            const isCompanyLogo = !!logo;
            const result = { logo, isCompanyLogo, format };
            logoCacheRef.current.set(clienteId, result);
            return result;
        } catch {
            return { logo: undefined, isCompanyLogo: false, format: 'PNG' };
        }
    };

    const updatePresenzaRows = async (rows, presenza) => {
        if (!Array.isArray(rows) || rows.length === 0) {
            return;
        }

        const nextCorsiPresenze = corsiPresenze.map((giornoRows, giornoIndex) =>
            giornoIndex !== value
                ? giornoRows
                : giornoRows.map((row) =>
                      rows.some((selectedRow) => selectedRow.ID === row.ID)
                          ? { ...row, presenza }
                          : row
                  )
        );

        setCorsiPresenze(nextCorsiPresenze);
        setPresenzeDirty(true);
        if (rows.some((row) => Number(row.presenza) !== Number(presenza))) {
            const nextCurrentRows = nextCorsiPresenze?.[value] || [];
            const nextSelectedIds = selectedPresenzeIds.filter((id) => {
                const currentRow = nextCurrentRows.find(
                    (row) => Number(row.ID) === Number(id)
                );
                return currentRow ? isPrintablePresenza(currentRow) : false;
            });
            syncAttestatiSelection(nextSelectedIds, nextCurrentRows);
        }
    };

    const handleClickCheckBox = async (e, element) => {
        await updatePresenzaRows([element], e.target.checked ? 1 : 0);
    };

    const handleToggleAllPresenze = async (checked) => {
        await updatePresenzaRows(currentPresenzeRows, checked ? 1 : 0);
    };

    const restorePresenzeSnapshot = () => {
        setCorsiPresenze(clonePresenzeRows(presenzeSnapshotRef.current));
        setPresenzeDirty(false);
        setSelectedPresenzeIds([]);
        setStampa(false);
    };

    const handleClosePresenzeDialog = () => {
        restorePresenzeSnapshot();
        setOpenPartecipanti(false);
        setHideDialog(false);
    };

    useEffect(() => {
        if (!openPartecipanti) {
            return;
        }
        setSelectedPresenzeIds([]);
        setStampa(false);
    }, [value, openPartecipanti]);

    useEffect(() => {
        if (!openPartecipanti) {
            return undefined;
        }

        const handleWindowError = (event) => {
            const message =
                event?.error?.message || event?.message || 'Unknown error';
            const stack = event?.error?.stack || '';

            if (
                !message.includes('reading \'type\'') &&
                !stack.includes('GridRow')
            ) {
                return;
            }

            console.error('Presenze grid runtime error', {
                message,
                stack,
                lastInteraction: lastPresenzeGridInteractionRef.current,
            });
        };

        window.addEventListener('error', handleWindowError);
        return () => {
            window.removeEventListener('error', handleWindowError);
        };
    }, [openPartecipanti]);

    const handleSavePresenze = async () => {
        if (savingPresenze || !presenzeDirty) {
            return;
        }

        const currentRows = clonePresenzeRows(corsiPresenze);
        const snapshotRows = presenzeSnapshotRef.current || [];
        const snapshotById = new Map();
        snapshotRows.forEach((giornoRows) => {
            (giornoRows || []).forEach((row) => {
                snapshotById.set(row.ID, row);
            });
        });

        const changedRows = [];
        currentRows.forEach((giornoRows) => {
            (giornoRows || []).forEach((row) => {
                const originalRow = snapshotById.get(row.ID);
                if (
                    originalRow &&
                    Number(originalRow.presenza) !== Number(row.presenza)
                ) {
                    changedRows.push(row);
                }
            });
        });

        if (changedRows.length === 0) {
            setPresenzeDirty(false);
            return;
        }

        setSavingPresenze(true);
        try {
            await Promise.all(
                changedRows.map((row) =>
                    unsplash.put(
                        'dettaglioCorsi',
                        {
                            corsoPresenza: {
                                Presenza: row.presenza,
                                Fatturato: row.Fatturato,
                                ID: row.ID,
                            },
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                            },
                        }
                    )
                )
            );

            presenzeSnapshotRef.current = clonePresenzeRows(currentRows);
            setPresenzeDirty(false);
            props.setSnack({
                severity: 'success',
                messaggio: 'Presenze salvate con successo',
            });
            props.setOpenSnack(true);
        } catch {
            props.setSnack({
                severity: 'error',
                messaggio: "Errore durante il salvataggio delle presenze",
            });
            props.setOpenSnack(true);
        } finally {
            setSavingPresenze(false);
        }
    };

    const handleMenuItemClick = (event, index) => {
        document.getElementById(`${index}`).click();
        //setSelectedIndex(index);
        setOpenButton(false);
    };

    const handleMenuItemClickReport = (event, index) => {
        document.getElementById(`${index}`).click();
        //setSelectedIndex(index);
        setOpenButtonReport(false);
    };

    const getBulkImportClienteId = () => {
        const explicitClienteId = Number(props.idAzienda || props.idCliente || 0);
        if (explicitClienteId) return explicitClienteId;

        const ids = new Set();
        clienti.forEach((cliente) => {
            const id = Number(cliente?.IDCliente || cliente?.Cliente || cliente?.ID);
            if (id) ids.add(id);
        });
        (corsiPresenze || []).flat().forEach((presenza) => {
            const id = Number(presenza?.IDCliente || presenza?.Cliente);
            if (id) ids.add(id);
        });

        return ids.size === 1 ? Array.from(ids)[0] : null;
    };

    const handleOpenBulkImport = () => {
        const clienteId = getBulkImportClienteId();
        if (!clienteId) {
            props.setSnack({
                severity: 'error',
                messaggio:
                    'Import attestati disponibile solo per aule con partecipanti di una sola azienda',
            });
            props.setOpenSnack(true);
            return;
        }
        setBulkImportClienteId(clienteId);
        setOpenBulkImport(true);
    };

    const handleToggleButton = () => {
        setOpenButton(!openButton);
    };

    const handleCloseButton = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpenButton(false);
    };

    function cap(arr) {
        for (var i = 0; i < arr.length; i++) {
            arr[i] =
                arr[i].charAt(0).toUpperCase() +
                arr[i].substring(1).toLowerCase();
        }
        return arr.join(' ');
    }
    const handleToggleButtonReport = () => {
        setOpenButtonReport(!openButtonReport);
    };

    const handleCloseButtonReport = (event) => {
        if (
            anchorRefReport.current &&
            anchorRefReport.current.contains(event.target)
        ) {
            return;
        }
        setOpenButtonReport(false);
    };

    const getFreshPrintablePresenze = async (tipo) => {
        if (presenzeDirty && corsoH.Modalita !== 2) {
            props.setSnack({
                severity: 'warning',
                messaggio:
                    'Salva prima le presenze: la stampa verifica i presenti a database',
            });
            props.setOpenSnack(true);
            return null;
        }

        const currentCorsoR = corsiR?.[value];
        if (!currentCorsoR || !idCorso) {
            props.setSnack({
                severity: 'error',
                messaggio: 'Impossibile verificare le presenze del giorno',
            });
            props.setOpenSnack(true);
            return null;
        }

        const response = await unsplash.get('dettaglioCorsi', {
            params: {
                tipologia: 'Presenze',
                corso: idCorso,
                corsiR: [currentCorsoR],
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        });

        const freshRows = response?.data?.data?.[0] || [];
        const selectedIDs = new Set(selectedPresenzeIds.map(Number));
        const printableRows = filterPrintablePresenze(
            tipo === 'all'
                ? freshRows
                : freshRows.filter((row) => selectedIDs.has(Number(row.ID)))
        );
        // Validate the whole batch before creating or associating any PDF.
        return printableRows.map((row) => ({
            ...row,
            attestatoPeriod: getAttestatoPeriod({
                modalita: corsoH.Modalita,
                participant: row,
                course: props.corsoH,
                lessons: corsiR,
            }),
        }));
    };

    const exportPDF = async (tipo) => {
        //FUNZIONE PER GENERARE I CERTIFICATI
        const unit = 'pt';
        const size = 'A4'; // Use A1, A2, A3 or A4
        const orientation = 'portrait'; // portrait or landscape
        const doc = new jsPDF(orientation, unit, size);
        const img = new Image();
        img.src = require('../assets/images/bg/background_attestato.png');

        const totaleOre = corsiR.reduce((somma, corso) => {
            return somma + corso.Durata;
        }, 0);

        let presenze = [];

        try {
            presenze = await getFreshPrintablePresenze(tipo);
        } catch (error) {
            props.setSnack({
                severity: 'error',
                messaggio: error.attestatoDateError
                    ? error.message
                    : 'Errore durante la verifica delle presenze',
            });
            props.setOpenSnack(true);
            return;
        }

        if (!presenze) {
            return;
        }

        if (presenze.length === 0) {
            props.setSnack({
                severity: 'error',
                messaggio: 'Seleziona almeno un partecipante presente',
            });
            props.setOpenSnack(true);
            return;
        }

        const width = doc.internal.pageSize.getWidth();
        const height = doc.internal.pageSize.getHeight();
        let idCliente = undefined;
        const defaultBackground = new Image();
        defaultBackground.src = require('../assets/images/backCertificate_astm.png');
        let logo = { logo: undefined, isCompanyLogo: false, format: 'PNG' };
        if (presenze.length > 0) {
            startCertProgress(presenze.length);
            await yieldToUi();
        }
        try {
            for (let i = 0; i < presenze.length; i++) {
                if (presenze[i].IDCliente !== idCliente) {
                    logo = await getLogo(presenze[i].IDCliente);
                    idCliente = presenze[i].IDCliente;
                }
                updateCertProgress(i + 1, presenze.length);
                if ((i + 1) % 5 === 0) {
                    await yieldToUi();
                }
                if (logo.isCompanyLogo && logo.logo) {
                    doc.addImage(img, 'PNG', 0, 0, width, height);
                    try {
                        const {
                            width: logoWidth = 0,
                            height: logoHeight = 0,
                        } = doc.getImageProperties(logo.logo);
                        const targetWidth = 150;
                        const scaledHeight =
                            logoWidth && logoHeight
                                ? Math.min(150, (logoHeight * targetWidth) / logoWidth)
                                : 80;
                        doc.addImage(
                            logo.logo,
                            logo.format || 'PNG',
                            30,
                            30,
                            targetWidth,
                            scaledHeight
                        );
                    } catch (e) {
                        console.error('Errore addImage logo attestato', e);
                        doc.addImage(defaultBackground, 'PNG', 0, 0, width, height);
                    }
                } else {
                    // default scenario with background + logo
                    doc.addImage(defaultBackground, 'PNG', 0, 0, width, height);
                }

            doc.setFontSize(12);
            doc.setFontSize(24);
            doc.setTextColor(34, 100, 174);
            doc.setFont(undefined, 'bold');
            //assegno l'ID dei Corsi_Presenze
            /*QRCode.toDataURL(`${presenze[i].ID}`, opts, function (err, url) {
        if (err) throw err;
        qrcode.src = url;
        doc.addImage(qrcode, "JPEG", 33, 107, 50, 50);
      });*/
            doc.text('ATTESTATO DI PARTECIPAZIONE', 33, 195);
            doc.setFontSize(12);
            doc.setTextColor(0, 0, 0);
            doc.text(
                doc.splitTextToSize(
                    `${corsiAttestati[0].Attestato1}`,
                    doc.internal.pageSize.getWidth() - 150
                ),
                33,
                215
            );
            doc.text('Si attesta che:', 33, 265);
            doc.setFontSize(16);
            doc.setTextColor(34, 100, 174);

            //massimo 28 lettere se no spezzo

            doc.text(
                presenze[i].Nome
                    ? cap(presenze[i].Nome.split(' ')) +
                          ' ' +
                          (presenze[i].Cognome
                              ? cap(presenze[i].Cognome.split(' '))
                              : '')
                    : presenze[i].Cognome
                      ? cap(presenze[i].Cognome.split(' '))
                      : '',
                33,
                290
            );
            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);
            doc.text('CF: ', 33, 310);
            doc.setFont(undefined, 'normal');
            doc.text(documentCfValue(presenze[i]), 52, 310);
            doc.setFont(undefined, 'bold');
            doc.text('LUOGO DI NASCITA: ', 33, 325);
            doc.setFont(undefined, 'normal');
            doc.text(
                presenze[i].LuogoDiNascita ? presenze[i].LuogoDiNascita : '',
                136,
                325
            );
            doc.setFont(undefined, 'bold');
            doc.text('DATA DI NASCITA: ', 33, 340);
            doc.setFont(undefined, 'normal');
            doc.text(
                presenze[i].DataDiNascita
                    ? moment(presenze[i].DataDiNascita).format('DD/MM/YYYY')
                    : '',
                127,
                340
            );

            doc.setFont(undefined, 'bold');
            doc.text(
                `HA PARTECIPATO E SUPERATO LE PROVE FINALI DEL CORSO${
                    corsoH.Aggiornamento === 1 ? ' DI AGGIORNAMENTO' : ''
                }:`,
                33,
                365
            );
            doc.setFontSize(14);
            doc.setTextColor(34, 100, 174);
            doc.text(
                doc.splitTextToSize(
                    `${corsiAttestati[0].Attestato2.toUpperCase()}` ||
                        corsoH.Descrizione,
                    doc.internal.pageSize.getWidth() - 50
                ),
                33,
                385
            );

            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);

            if (totaleOre) {
                doc.text('MONTE ORE FREQUENTATO: ', 33, 425);
                doc.setFont(undefined, 'normal');
                doc.text(totaleOre + ' ORE', 178, 425);
            }

            doc.setFont(undefined, 'bold');

            if (presenze[i].CodiceATECO) {
                doc.text('SETTORE DI RIFERIMENTO: ', 33, 440);
                doc.setFont(undefined, 'normal');
                doc.text(
                    presenze[i].CodiceATECO ? presenze[i].CodiceATECO : '',
                    170,
                    440
                );
            }
            doc.setFont(undefined, 'bold');

            if (corsoH.Modalita !== 2) {
                doc.text('IL SOGGETTO ORGANIZZATORE:', 33, 455);
                doc.setFont(undefined, 'normal');
                doc.text(presenze[i].RagioneSociale, 198, 455);
                doc.setFont(undefined, 'bold');

                if (`${formatore?.Nome ?? ''} ${formatore?.Cognome ?? ''}`.trim()) {
                    doc.text('IL SOGGETTO FORMATORE:', 33, 470);
                    doc.setFont(undefined, 'normal');
                    doc.text(
                        `${formatore?.Nome ?? ''} ${formatore?.Cognome ?? ''}`.trim() ||
                            '-',
                        175,
                        470
                    );
                }

            }
            doc.setFont(undefined, 'bold');
            doc.text('SEDE/MODALITÀ DI EROGAZIONE DEL CORSO:', 33, 485);
            doc.setFont(undefined, 'normal');
            const modalitaDescrizione = (
                modalita?.Descrizione ||
                corsoH?.ModalitaDescrizione ||
                ''
            )
                .toString()
                .toLowerCase();
            let luogo = modalitaDescrizione.includes('videoconferenza')
                ? 'VIDEOCONFERENZA'
                : modalitaDescrizione.includes('online') ||
                    modalitaDescrizione.includes('e-learning') ||
                    modalitaDescrizione.includes('elearning')
                  ? 'E-LEARNING'
                  : corsoH.Luogo === null
                    ? 'FRANCOLINO DI MEDIGLIA'
                    : corsoH.Luogo;
            doc.text(luogo, 265, 485);
            doc.setFont(undefined, 'bold');
            doc.text('PERIODO DI SVOLGIMENTO DEL CORSO: ', 33, 500);
            doc.setFont(undefined, 'normal');

            doc.text(
                `${presenze[i].attestatoPeriod.startText} - ${presenze[i].attestatoPeriod.endText}`,
                237,
                500
            );

            /* test azzurro chiaro */
            doc.setTextColor(141, 196, 235);

            doc.text(
                doc.splitTextToSize(
                    `${corsiAttestati[0].Attestato3}`,
                    doc.internal.pageSize.getWidth() - 200
                ),
                200,
                565
            );

            if (corsoH.Modalita !== 2) {
                doc.setTextColor(0, 0, 0);
                var title = 'IL FORMATORE';
                let xOffset =
                    doc.internal.pageSize.width / 2 -
                    (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
                        2;
                doc.text(title, xOffset, 635);

                doc.setTextColor(0, 0, 0);
                var title2 = 'IL SOGGETTO ORGANIZZATORE';
                let xOffset2;
                xOffset2 =
                    20 +
                    doc.internal.pageSize.width / 2 +
                    doc.internal.pageSize.width / 4 -
                    (doc.getStringUnitWidth(title2) * doc.internal.getFontSize()) /
                        2;
                doc.text(title2, xOffset2, 635);
                doc.setTextColor(0, 0, 0);
                doc.text(presenze[i].RagioneSociale, xOffset2, 650);

                if (formatore) {
                    var title1 = `${formatore.Nome} ${formatore.Cognome}`;
                    xOffset =
                        doc.internal.pageSize.width / 2 -
                        (doc.getStringUnitWidth(title1) *
                            doc.internal.getFontSize()) /
                            2;
                    doc.text(title1, xOffset, 650);
                }
            }
            if (i !== presenze.length - 1) {
                doc.addPage();
            }
            }
            openPdf(doc, buildAttestatiFilename());
        } finally {
            endCertProgress();
        }
    };

    const exportPDFPartecipanti = (tipo, date, persone, corso) => {
        const unit = 'pt';
        const size = 'A4'; // Use A1, A2, A3 or A4
        const orientation = 'portrait'; // portrait or landscape

        const doc = new jsPDF(orientation, unit, size);
        const img = new Image();
        img.src = require('../assets/images/logoBlack.png');

        const imgLogo = new Image();
        imgLogo.src = require('../assets/images/Logo-ASTM.png');

        const headers = ['N', 'COGNOME', 'NOME', 'DATA CONSEGNA', 'FIRMA'];
        var count = 1;
        const data = persone.map((el) => [
            `${count++}/${persone.length}`,
            cap(el.Cognome.split(' ')),
            cap(el.Nome.split(' ')),
            '',
            '',
        ]);

        let content = {
            startY: 210,
            startX: 0,
            tableWidth: 'auto',
            columnWidth: 'auto',
            headStyles: { fillColor: [34, 100, 174] },
            footStyles: { fillColor: [34, 100, 174] },
            margin: { left: 33, right: 33 },
            showFoot: 'lastPage',
        };

        let presenze = [];

        if (!giornoSel) {
            props.setSnack({
                severity: 'error',
                messaggio: 'Seleziona almeno un giorno',
            });
            props.setOpenSnack(true);
            return;
        } else {
            setOpen(true);
        }

        if (tipo === 'all') {
            presenze = corsiPresenze[0];
        } else {
            presenze = giornoSel;
        }

        for (let i = 0; i < presenze.length; i++) {
            doc.addImage(imgLogo, 'PNG', 10, 30, 318.9, 94.5);
            doc.setFontSize(24);
            doc.setTextColor(34, 100, 174);
            doc.setFont(undefined, 'bold');
            doc.text('REGISTRO CONSEGNA ATTESTATI', 33, 200);

            doc.setFontSize(16);
            doc.setTextColor(34, 100, 174);
            doc.setFont(undefined, 'normal');
            doc.text('DENOMINAZIONE CORSO:', 33, 250);
            doc.setFontSize(14);
            doc.setTextColor(0, 0, 0);
            doc.setFont(undefined, 'bold');
            doc.text(corso.Descrizione, 33, 270);
            doc.setFontSize(16);
            doc.setTextColor(34, 100, 174);
            doc.setFont(undefined, 'normal');
            doc.text('DURATA COMPLESSIVA:', 33, 310);
            doc.setFontSize(14);
            doc.setTextColor(0, 0, 0);
            doc.setFont(undefined, 'bold');
            doc.text(presenze[i].Durata + 'h', 33, 330);

            doc.setFontSize(16);
            doc.setTextColor(34, 100, 174);
            doc.setFont(undefined, 'normal');
            doc.text('DATA - DURATA - ORARI:', 33, 350);

            doc.setFontSize(14);
            doc.setTextColor(0, 0, 0);
            doc.setFont(undefined, 'bold');

            doc.text(
                moment(presenze[i].Data).format('DD/MM/YYYY') +
                    ' - ' +
                    presenze[i].Durata +
                    'h - dalle ' +
                    presenze[i].Ora.slice(0, 2) +
                    ' alle ' +
                    (presenze[i].Durata > 4
                        ? parseInt(presenze[i].Ora.slice(0, 2)) +
                          presenze[i].Durata +
                          1
                        : parseInt(presenze[i].Ora.slice(0, 2)) +
                          presenze[i].Durata),
                33,
                370
            );
            doc.setFontSize(16);
            doc.setTextColor(34, 100, 174);
            doc.setFont(undefined, 'normal');
            doc.text('RESPONSABILE DEL PROGETTO FORMATIVO:', 33, 390);
            doc.setFontSize(14);
            doc.setTextColor(0, 0, 0);
            doc.setFont(undefined, 'bold');
            let formatore = props.Formatori?.filter(
                (p) => p.ID === corsoH?.Formatore
            )[0];
            const nomeCompleto = formatore?.Nome + ' ' + formatore?.Cognome;

            doc.text(nomeCompleto, 33, 410);

            doc.setFontSize(16);
            doc.setTextColor(34, 100, 174);
            doc.setFont(undefined, 'normal');
            doc.text('SOGGETTO ORGANIZZATORE DEL CORSO:', 33, 430);
            doc.setFontSize(14);
            doc.setTextColor(0, 0, 0);
            doc.setFont(undefined, 'bold');
            doc.text('', 33, 450);

            doc.setTextColor(0, 0, 0);
            doc.setFont(undefined, 'normal');

            var title = 'SOGGETTO ORGANIZZATORE',
                xOffset =
                    doc.internal.pageSize.width / 4 -
                    (doc.getStringUnitWidth(title) *
                        doc.internal.getFontSize()) /
                        2;
            doc.text(title, xOffset, 635);
            var title2 = 'DEL CORSO',
                xOffset2 =
                    doc.internal.pageSize.width / 4 -
                    (doc.getStringUnitWidth(title2) *
                        doc.internal.getFontSize()) /
                        2;
            doc.text(title2, xOffset2, 650);

            doc.setTextColor(34, 100, 174);
            doc.setFont(undefined, 'bold');
            var title3 = 'DATORE DI LAVORO',
                xOffset3 =
                    doc.internal.pageSize.width / 4 -
                    (doc.getStringUnitWidth(title3) *
                        doc.internal.getFontSize()) /
                        2;
            doc.text(title3, xOffset3, 665);

            if (formatore?.Nome || formatore?.Cognome || formatore?.Firma) {
                doc.setTextColor(0, 0, 0);
                doc.setFont(undefined, 'normal');
                var title0 = 'IL FORMATORE',
                    xOffset0 =
                        doc.internal.pageSize.width / 2 +
                        doc.internal.pageSize.width / 4 -
                        (doc.getStringUnitWidth(title0) *
                            doc.internal.getFontSize()) /
                            2;
                doc.text(title0, xOffset0, 635);

                doc.setTextColor(34, 100, 174);
                doc.setFont(undefined, 'bold');
                var title1 = '',
                    xOffset1 =
                        doc.internal.pageSize.width / 2 +
                        doc.internal.pageSize.width / 4 -
                        (doc.getStringUnitWidth(title1) *
                            doc.internal.getFontSize()) /
                            2;
                doc.text(title1, xOffset1, 650);
                const imgFirma = new Image();
                if (formatore?.Firma) {
                    imgFirma.src = 'data:image/png;base64,' + formatore.Firma;
                    doc.addImage(
                        imgFirma,
                        'PNG',
                        350,
                        670,
                        200,
                        imgFirma.height / 2
                    );
                }
            }
            if (i !== presenze.length - 1) {
                doc.addPage();
            }
            doc.addPage();
            doc.addImage(imgLogo, 'PNG', 10, 30, 318.9, 94.5);
            doc.setFontSize(12);
            doc.setTextColor(0, 0, 0);
            doc.setFont(undefined, 'bold');
            doc.text(
                doc.splitTextToSize(
                    "Con la presente si dichiara che a seguito del superamento del test finale, i discenti sotto elencati ricevono gli attestati di frequenza del corso '" +
                        corso.Descrizione +
                        "'. Dichiarano inoltre di aver frequentato, come riportato nel registro presenze, almeno il 90% del monte ore totale e previsto (" +
                        presenze[i].Durata +
                        'h)',
                    doc.internal.pageSize.getWidth() - 80
                ),
                33,
                150
            );
        }
        doc.autoTable(headers, data, content);

        //if()
        openPdf(doc, 'attestato.pdf');
    };

    const exportPDFPresenze = (tipo, date, persone, corso) => {
        const unit = 'pt';
        const size = 'A4'; // Use A1, A2, A3 or A4
        const orientation = 'portrait'; // portrait or landscape
        let presenze = [];
        if (tipo === 'all') {
            presenze = corsiR;
        } else {
            presenze = giornoSel;
        }
        /* durata complessiva corsi */
        const durata = presenze.map((a) => parseInt(a.Durata));
        const tot = durata.reduce((partialSum, a) => partialSum + a, 0);

        /* orario entrata uscita */

        const doc = new jsPDF(orientation, unit, size);
        const img = new Image();
        img.src = require('../assets/images/logoBlack.png');

        const imgLogo = new Image();
        imgLogo.src = require('../assets/images/Logo-ASTM.png');

        const headerDocenti = (val) => {
            return [
                'NOME',
                'COGNOME',
                `ENTRATA ${val.Ora.slice(0, 2)}:00`,
                `USCITA ${
                    val.Durata > 4
                        ? parseInt(val.Ora.slice(0, 2)) + val.Durata + 1
                        : parseInt(val.Ora.slice(0, 2)) + val.Durata
                }:00`,
            ];
        };
        const headerDiscenti = (val) => {
            return [
                'N',
                'COGNOME',
                'NOME',
                `ENTRATA ${val.Ora.slice(0, 2)}:00`,
                `USCITA ${
                    val.Durata > 4
                        ? parseInt(val.Ora.slice(0, 2)) + val.Durata + 1
                        : parseInt(val.Ora.slice(0, 2)) + val.Durata
                }:00`,
            ];
        };
        var count = 1;
        const data = persone.map((el) => [
            `${count++}/${persone.length}`,
            cap(el.Cognome.split(' ')),
            cap(el.Nome.split(' ')),
            '',
            '',
        ]);
        const formatore = props.Formatori?.filter(
            (p) => p.ID === corsoH?.Formatore
        )[0];
        const nomeCompleto = formatore?.Nome + ' ' + formatore?.Cognome;
        const docenti = [nomeCompleto.split(' ')];

        let contentDocenti = {
            startY: 150,
            startX: 0,
            tableWidth: 'auto',
            columnWidth: 'auto',
            headStyles: { fillColor: [34, 100, 174] },
            footStyles: { fillColor: [34, 100, 174] },
            margin: { left: 33, right: 33 },
            showFoot: 'lastPage',
        };

        let contentDiscenti = {
            startY: 270,
            startX: 0,
            tableWidth: 'auto',
            columnWidth: 'auto',
            headStyles: { fillColor: [34, 100, 174] },
            footStyles: { fillColor: [34, 100, 174] },
            margin: { left: 33, right: 33 },
            showFoot: 'lastPage',
        };

        setOpen(true);
        doc.addImage(imgLogo, 'PNG', 10, 30, 318.9, 94.5);
        doc.setFontSize(24);
        doc.setTextColor(34, 100, 174);
        doc.setFont(undefined, 'bold');
        doc.text('REGISTRO PRESENZE', 33, 200);

        doc.setFontSize(16);
        doc.setTextColor(34, 100, 174);
        doc.setFont(undefined, 'normal');
        doc.text('DENOMINAZIONE CORSO:', 33, 250);
        doc.setFontSize(14);
        doc.setTextColor(0, 0, 0);
        doc.setFont(undefined, 'bold');
        doc.text(
            corso.Descrizione +
                (corsoH.Aggiornamento === 1 ? ' - Aggiornamento' : ''),
            33,
            270
        );
        doc.setFontSize(16);
        doc.setTextColor(34, 100, 174);
        doc.setFont(undefined, 'normal');
        doc.text(`DURATA COMPLESSIVA: `, 33, 310);
        doc.setFontSize(14);
        doc.setTextColor(0, 0, 0);
        doc.setFont(undefined, 'bold');
        //sommo tutte le ore dei corsi

        doc.text(tot + 'h', 33, 330);

        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.setFont(undefined, 'bold');
        doc.setFontSize(16);
        doc.setTextColor(34, 100, 174);
        doc.setFont(undefined, 'normal');
        doc.text(`RESPONSABILE DEL PROGETTO FORMATIVO:`, 33, 350);
        doc.setFontSize(14);
        doc.setTextColor(0, 0, 0);
        doc.setFont(undefined, 'bold');
        doc.text(cap(nomeCompleto.split(' ')), 33, 370);

        doc.setFontSize(16);
        doc.setTextColor(34, 100, 174);
        doc.setFont(undefined, 'normal');
        doc.text('SOGGETTO ORGANIZZATORE DEL CORSO:', 33, 390);
        doc.setFontSize(14);
        doc.setTextColor(0, 0, 0);
        doc.setFont(undefined, 'bold');
        doc.text('', 33, 410);

        doc.setFontSize(16);
        doc.setTextColor(34, 100, 174);
        doc.setFont(undefined, 'normal');
        doc.text('DATA - DURATA - ORARI:', 33, 430);

        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.setFont(undefined, 'bold');
        for (let i = 0; i < presenze.length; i++) {
            doc.text(
                moment(presenze[i].Data).format('DD/MM/YYYY') +
                    ' - ' +
                    presenze[i].Durata +
                    'h - dalle ' +
                    presenze[i].Ora.slice(0, 2) +
                    ' alle ' +
                    (presenze[i].Durata > 4
                        ? parseInt(presenze[i].Ora.slice(0, 2)) +
                          presenze[i].Durata +
                          1
                        : parseInt(presenze[i].Ora.slice(0, 2)) +
                          presenze[i].Durata),
                33,
                i * 12 + 445
            );
        }

        doc.setTextColor(0, 0, 0);
        doc.setFont(undefined, 'normal');

        var title = 'SOGGETTO ORGANIZZATORE',
            xOffset =
                doc.internal.pageSize.width / 4 -
                (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
                    2;
        doc.text(title, xOffset, 635);
        var title2 = 'DEL CORSO',
            xOffset2 =
                doc.internal.pageSize.width / 4 -
                (doc.getStringUnitWidth(title2) * doc.internal.getFontSize()) /
                    2;
        doc.text(title2, xOffset2, 650);

        doc.setTextColor(34, 100, 174);
        doc.setFont(undefined, 'bold');
        var title3 = 'DATORE DI LAVORO',
            xOffset3 =
                doc.internal.pageSize.width / 4 -
                (doc.getStringUnitWidth(title3) * doc.internal.getFontSize()) /
                    2;
        doc.text(title3, xOffset3, 665);

        if (formatore?.Nome || formatore?.Cognome || formatore?.Firma) {
            doc.setTextColor(0, 0, 0);
            doc.setFont(undefined, 'normal');
            var title0 = 'IL FORMATORE',
                xOffset0 =
                    doc.internal.pageSize.width / 2 +
                    doc.internal.pageSize.width / 4 -
                    (doc.getStringUnitWidth(title0) * doc.internal.getFontSize()) /
                        2;
            doc.text(title0, xOffset0, 635);

            doc.setTextColor(34, 100, 174);
            doc.setFont(undefined, 'bold');
            var title1 = '',
                xOffset1 =
                    doc.internal.pageSize.width / 2 +
                    doc.internal.pageSize.width / 4 -
                    (doc.getStringUnitWidth(title1) * doc.internal.getFontSize()) /
                        2;
            doc.text(title1, xOffset1, 650);

            if (formatore?.Firma) {
                const imgFirma = new Image();
                imgFirma.src = 'data:image/png;base64,' + formatore.Firma;

                doc.addImage(imgFirma, 'PNG', 350, 670, 200, imgFirma.height / 2);
            }
        }

        for (let i = 0; i < presenze.length; i++) {
            doc.addPage();
            doc.setFontSize(14);
            doc.setTextColor(0, 0, 0);
            doc.setFont(undefined, 'normal');
            doc.text(`${corso.Descrizione}`, 33, 100);
            doc.text(
                `DURATA: ${presenze[i].Durata}h - DATA: ${moment(
                    presenze[i].Data
                ).format('DD/MM/YYYY')}`,
                33,
                120
            );
            doc.setFontSize(14);
            doc.setTextColor(0, 0, 0);
            doc.setFont(undefined, 'bold');
            doc.text(`DOCENTI`, 33, 140);
            /* tabella Docenti */
            doc.autoTable(headerDocenti(presenze[i]), docenti, contentDocenti);

            doc.setFontSize(14);
            doc.setTextColor(0, 0, 0);
            doc.setFont(undefined, 'normal');
            doc.text(`${corso.Descrizione}`, 33, 220);
            doc.text(
                `DURATA: ${presenze[i].Durata}h - DATA: ${moment(
                    presenze[i].Data
                ).format('DD/MM/YYYY')}`,
                33,
                240
            );
            doc.setFontSize(14);
            doc.setTextColor(0, 0, 0);
            doc.setFont(undefined, 'bold');
            doc.text(`DISCENTI`, 33, 260);
            /* tabella Discenti */
            doc.autoTable(headerDiscenti(presenze[i]), data, contentDiscenti);
        }
        openPdf(doc, 'presenze.pdf');
    };

    const handleCorsiAttestati = async (idCorsoo, agg) => {
        try {
            let res = await unsplash.get('corsiAttestati', {
                params: { idCorso: idCorsoo },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            });
            if (res.data.data.length === 0) {
                setStampa(false);
            } else if (res.data.data.length === 2) {
                setStampa(true);
                var formatoriX = [];
                var i;
                for (i = 0; i < res.data.data.length; i++) {
                    if (res.data.data[i].Aggiornamento === agg) {
                        formatoriX.push(res.data.data[i]);
                    }
                    setCorsiAttestati(formatoriX);
                }
            } else {
                setCorsiAttestati(res.data.data);
                setStampa(true);
            }
        } catch {
            props.setSnack({
                severity: 'error',
                messaggio: 'Errore durante il caricamento degli attestati',
            });
            props.setOpenSnack(true);
        }
    };

    const handleClickOpen = async () => {
        setValue(0);
        setOperation(props.Operation);
        setGiornoSel(null);
        setCorsiPresenze(null);
        setFormatore(null);
        setModalita(null);

        if (props.Operation === 'Nuovo') {
            //setCorsoH();
            setCodiceCorso(null);
        } else {
            await handleCorsiAttestati(props.Tipo, props.Aggiornamento);
            let ch = props.corsoH;

            setCorsoH({
                ID: ch.ID,
                Tipo: ch.Tipo,
                NomeEdizione: ch.NomeEdizione ?? '',
                Modalita: ch.Modalita,
                Formatore: ch.IDFormatore,
                NomeFormatore: ch.Formatore ?? '',
                Descrizione: ch.Descrizione ?? '',
                IdEdizionePigreco: ch.IdEdizionePigreco,
                Luogo: ch.Luogo ?? '',
                Aggiornamento: ch.Aggiornamento,
                Note: ch.Note ?? '',
                Visibile: ch.Visibile,
                PostiTotali: ch.PostiTotali ?? '',
            });

            setIdCorso(ch.ID);
            setCodiceCorso(props.Corsi.filter((p) => p.Codice === ch.Tipo)[0]);
            setModalita(props.Modalita.filter((p) => p.ID === ch.Modalita)[0]);
            setFormatore(
                props.Formatori.filter((p) => p.ID === ch.IDFormatore)[0]
            );
            //setLuogo(ch.LuogoLocalita)
            await handleLoadRighe(ch.ID);
            await handleLoadClientiCorso(props.corsoH.ID);
        }

        setOpen(true);
    };

    const handleClose = (shouldClose) => {
        setCorsoH({
            Tipo: null,
            NomeEdizione: '',
            Modalita: null,
            Formatore: null,
            Descrizione: '',
            NomeFormatore: '',
            Luogo: '',
            Aggiornamento: 0,
            Note: '',
            Visibile: 0,
            PostiTotali: 0,
        });
        setUpdated(false)
        setOpen(!shouldClose);
    };
    const handleCloseReport = () => {
        setOpenReport(false);
    };

    const handleCourseCreation = async () => {
        if (operation === 'Nuovo') {
            if (corsoH.Tipo === null) {
                props.setSnack({
                    severity: 'error',
                    messaggio: 'Corso Obbligatorio per la creazione',
                });
                props.setOpenSnack(true);
            } else {
                let corsoTemp = { ...corsoH };
                if (modalita.ID === 2) {
                    // se il corso è video allora creo l'edizione

                    let respEdizione;
                    try {
                        respEdizione = await unsplash.post(
                            'pigreco/createEdition',
                            { id: corsoH.Tipo },
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                                },
                            }
                        );
                    } catch (error) {
                        props.setSnack({
                            severity: 'error',
                            messaggio:
                                error.response?.data?.message ||
                                'Errore durante la creazione dell’edizione Pigreco',
                        });
                        props.setOpenSnack(true);
                        return;
                    }

                    let id_edizione = respEdizione.data.id;
                    if (!id_edizione) {
                        props.setSnack({
                            severity: 'error',
                            messaggio:
                                'Pigreco non ha restituito un id edizione valido',
                        });
                        props.setOpenSnack(true);
                        return;
                    }
                    corsoTemp.IdEdizionePigreco = id_edizione;
                }

                try {
                    const formData = new FormData();
                    formData.append('tipo', 'H');
                    formData.append('corso', JSON.stringify(corsoTemp));
                    files.forEach((file) => formData.append('file', file));
                    formData.append(
                        'fileCondivisi',
                        JSON.stringify(sharedFileNames)
                    );

                    const responseCorso = await unsplash.post(
                        'corsi',
                        formData,
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                                'Content-Type': 'multipart/form-data',
                            },
                        }
                    );
                    let idCorso = responseCorso.data.message.insertId;
                    setIdCorso(idCorso);
                    setCorsoH(corsoTemp);

                    if (modalita.ID === 2) {
                        //se il corso è online -> creo la R con data oggi
                        let corsoRiga = {
                            Corso: idCorso,
                            Data: moment(new Date()).format('YYYY-MM-DD'),
                        };
                        await unsplash.post(
                            'corsi',
                            { corso: corsoRiga, tipo: 'R' }, //Creo corso header STEP 1
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                                },
                            }
                        );
                    }

                    await handleLoadRighe(idCorso);
                    props.reloadCorsi();
                    setOperation('Edit');
                    props.setSnack({
                        severity: 'success',
                        messaggio: 'Corso salvato con successo',
                    });
                    props.setOpenSnack(true);
                    handleClose(false);
                } catch {
                    props.setSnack({
                        severity: 'error',
                        messaggio: "Errore durante l'aggiornamento",
                    });
                    props.setOpenSnack(true);
                }
            }
        } else {
            try {
                if (files && files.length > 0) {
                    const formData = new FormData();
                    formData.append('tipo', 'H');
                    formData.append('corso', JSON.stringify(corsoH));
                    files.forEach((file) => formData.append('file', file));
                    formData.append(
                        'fileCondivisi',
                        JSON.stringify(sharedFileNames)
                    );

                    await unsplash.put('corsi', formData, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                            'Content-Type': 'multipart/form-data',
                        },
                    });
                } else {
                    await unsplash.put(
                        'corsi',
                        { corso: corsoH, tipo: 'H' },
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                            },
                        }
                    );
                }

                props.reloadCorsi();
                props.setSnack({
                    severity: 'success',
                    messaggio: 'Corso modificato con successo',
                });
                props.setOpenSnack(true);
                setFiles([]);
                handleClose(true);
            } catch (error) {
                props.setSnack({
                    severity: 'error',
                    messaggio:
                        "Errore durante l'aggiornamento: " +
                        (error.response?.data?.message || error.message),
                });
                props.setOpenSnack(true);
            }
        }
    };

    const handleLoadRighe = async (idCorso) => {
        try {
            let response = await unsplash.get('corsi', {
                params: { idCorso: idCorso },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            });
            setCorsiR(response.data.data);
            setLoading(false);
            handleLoadPresenze(response.data.data, idCorso);
        } catch (error) {
            setLoading(false);
            props.setSnack({
                severity: 'error',
                messaggio:
                    'Errore nel ricaricare le righe corso: ' +
                    (error.response?.data?.message || error.message),
            });
            props.setOpenSnack(true);
        }
    };

    const handleLoadPresenze = async (cR, idCorso) => {
        //qua carico le presenze

        setLoadingPres(true);
        try {
            let response = await unsplash.get('dettaglioCorsi', {
                params: { tipologia: 'Presenze', corso: idCorso, corsiR: cR },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            });

            const presenzeData = clonePresenzeRows(response.data.data);
            setCorsiPresenze(presenzeData);
            presenzeSnapshotRef.current = clonePresenzeRows(presenzeData);
            setPresenzeDirty(false);
            setSelectedPresenzeIds([]);
            setStampa(false);
            console.debug('Presenze ricaricate', {
                idCorso,
                corsiR: cR?.length ?? 0,
                count: response?.data?.data?.[0]?.length ?? 0,
                pigrecoIds: response?.data?.data?.[0]
                    ?.map((item) => item.IDIscrizionePiGreco)
                    .filter((item) => item),
            });
            if (response?.data?.data?.length > 0) {
                setPostiRimanenti(response.data.data[0]?.length);
            }
            return presenzeData;
        } catch (error) {
            props.setSnack({
                severity: 'error',
                messaggio:
                    'Errore nel ricaricare le presenze: ' +
                    (error.response?.data?.message || error.message),
            });
            props.setOpenSnack(true);
            return null;
        } finally {
            setLoadingPres(false);
        }
    };

    const hadleReport = async (type, giorni, destinatari) => {
        if (corsoH?.Luogo === null || corsoH?.Luogo === '') {
            props.setSnack({
                severity: 'error',
                messaggio: 'Inserire il luogo',
            });
            props.setOpenSnack(true);
        } else if (corsoH?.Formatore === null || corsoH?.Formatore === '') {
            props.setSnack({
                severity: 'error',
                messaggio: 'Inserire il formatore',
            });
            props.setOpenSnack(true);
        } else if (corsoH?.Descrizione === null || corsoH?.Descrizione === '') {
            props.setSnack({
                severity: 'error',
                messaggio: 'Inserire la modalità',
            });
            props.setOpenSnack(true);
        } else {
            const corsi = giorni.map((el) => {
                return {
                    corso: corsoH.Descrizione,
                    giorno: moment(el?.Data).format('YYYY-MM-DD'),
                    ora: el?.Ora,
                    luogo: corsoH?.Luogo,
                    docente: corsoH?.NomeFormatore,
                    modalita: modalita?.Descrizione,
                };
            });
            let missingEmail = [];
            let emails = [];
            if (type === 'dipendenti') {
                destinatari.forEach((el) => {
                    if (el?.Email === null || el?.Email === '') {
                        missingEmail.push({
                            nome: el?.Nome,
                            cognome: el?.Cognome,
                        });
                    } else {
                        emails.push({
                            email: el?.Email,
                            nome: el?.Nome,
                            cognome: el?.Cognome,
                        });
                    }
                });
                setMissingEmail(missingEmail);
                if (emails.length === 0) {
                    props.setSnack({
                        severity: 'error',
                        messaggio: 'Lavoratori non presenti',
                    });
                    props.setOpenSnack(true);
                } else {
                    try {
                        await unsplash.post(
                            'report',
                            {
                                type: 'corsi',
                                dipendenti: emails,
                                corsi: corsi,
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                                },
                            }
                        );
                        props.setSnack({
                            severity: 'success',
                            messaggio: 'Report inviato con successo',
                        });
                        props.setOpenSnack(true);
                        if (missingEmail?.length !== 0) {
                            setOpenReport(true);
                        }
                    } catch (error) {
                        props.setSnack({
                            severity: 'error',
                            messaggio: "Errore durante l'invio del report",
                        });
                        props.setOpenSnack(true);
                    }
                }

                //variabili chiamata post: type: "corsi", corsi: giorni, dipendenti:destinatari
            } else {
                //variabili chiamata post: type: "corsi", corsi: giorni, referente:destinatari
                let lavoratori = [];

                destinatari.forEach((el) => {
                    const responsabili = emails?.map((el) => el?.email);
                    lavoratori.push({ nome: el?.Nome, cognome: el?.Cognome });
                    if (el?.Responsabile === null || el?.Responsabile === '') {
                        missingEmail.push({
                            nome: el?.Nome,
                            cognome: el?.Cognome,
                        });
                    } else {
                        if (!responsabili.includes(el?.Responsabile)) {
                            emails.push({
                                email: el?.Responsabile,
                                nome: el?.Nome,
                                cognome: el?.Cognome,
                            });
                        }
                    }
                });
                if (emails.length === 0) {
                    props.setSnack({
                        severity: 'error',
                        messaggio: 'Referenti non presenti',
                    });
                    props.setOpenSnack(true);
                } else if (lavoratori.length === 0) {
                    props.setSnack({
                        severity: 'error',
                        messaggio: 'Lavoratori non presenti',
                    });
                    props.setOpenSnack(true);
                } else {
                    try {
                        await unsplash.post(
                            'report',
                            {
                                type: 'corsi',
                                referenti: emails,
                                lavoratori: lavoratori,
                                corsi: corsi,
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                                },
                            }
                        );
                        props.setSnack({
                            severity: 'success',
                            messaggio: 'Report inviato con successo',
                        });
                        props.setOpenSnack(true);
                        if (missingEmail?.length !== 0) {
                            setOpenReport(true);
                        }
                    } catch (error) {
                        props.setSnack({
                            severity: 'error',
                            messaggio: "Errore durante l'invio del report",
                        });
                        props.setOpenSnack(true);
                    }
                }
            }
        }
    };

    const handleLoadClientiCorso = async (idCorso) => {
        let response = await unsplash.get('modalitaFatturazioneCorsi', {
            params: { IDCorso: idCorso },
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        });

        setClienti(response.data.data);
    };

    const exportPDFwithAssociation = async (tipo) => {
        //FUNZIONE PER GENERARE I CERTIFICATI
        const unit = 'pt';
        const size = 'A4'; // Use A1, A2, A3 or A4
        const orientation = 'portrait'; // portrait or landscape
        const doc = new jsPDF(orientation, unit, size);
        var img = new Image();
        var qrcode = new Image();
        img.src = require('../assets/images/bg/background_attestato.png');

        if (!corsiAttestati?.length || !corsiAttestati[0]?.Attestato1) {
            props.setSnack({
                severity: 'error',
                messaggio: 'Configurazione attestato mancante',
            });
            props.setOpenSnack(true);
            return;
        }

        const totaleOre = corsiR.reduce((somma, corso) => {
            return somma + corso.Durata;
        }, 0);

        let presenze = [];

        try {
            presenze = await getFreshPrintablePresenze(tipo);
        } catch (error) {
            props.setSnack({
                severity: 'error',
                messaggio: error.attestatoDateError
                    ? error.message
                    : 'Errore durante la verifica delle presenze',
            });
            props.setOpenSnack(true);
            return;
        }

        if (!presenze) {
            return;
        }

        if (presenze.length === 0) {
            props.setSnack({
                severity: 'error',
                messaggio: 'Seleziona almeno un partecipante presente',
            });
            props.setOpenSnack(true);
            return;
        }

        var opts = {
            errorCorrectionLevel: 'H',
            type: 'image/jpeg',
            quality: 0.3,
            margin: 1,
            color: {
                //dark: "#000000",
                dark: '#2264ae',
                light: '#FFFFFF',
            },
        };

        const width = doc.internal.pageSize.getWidth();
        const height = doc.internal.pageSize.getHeight();
        let idCliente = undefined;
        const defaultBackground = new Image();
        defaultBackground.src = require('../assets/images/backCertificate_astm.png');
        let logo = { logo: undefined, isCompanyLogo: false, format: 'PNG' };
        if (presenze.length > 0) {
            startCertProgress(presenze.length);
            await yieldToUi();
            try {
                for (let i = 0; i < presenze.length; i++) {
                    if (presenze[i].IDCliente !== idCliente) {
                        logo = await getLogo(presenze[i].IDCliente);
                        idCliente = presenze[i].IDCliente;
                    }
                    updateCertProgress(i + 1, presenze.length);
                    if ((i + 1) % 5 === 0) {
                        await yieldToUi();
                    }
                    if (logo.isCompanyLogo && logo.logo) {
                        doc.addImage(img, 'PNG', 0, 0, width, height);
                        try {
                            const {
                                width: logoWidth = 0,
                                height: logoHeight = 0,
                            } = doc.getImageProperties(logo.logo);
                            const targetWidth = 150;
                            const scaledHeight =
                                logoWidth && logoHeight
                                    ? Math.min(
                                          150,
                                          (logoHeight * targetWidth) / logoWidth
                                      )
                                    : 80;
                            doc.addImage(
                                logo.logo,
                                logo.format || 'PNG',
                                30,
                                30,
                                150,
                                scaledHeight
                            );
                        } catch (e) {
                            console.error('Errore addImage logo attestato', e);
                            doc.addImage(
                                defaultBackground,
                                'PNG',
                                0,
                                0,
                                width,
                                height
                            );
                        }
                    } else {
                        // default scenario with background + logo
                        doc.addImage(defaultBackground, 'PNG', 0, 0, width, height);
                    }
                doc.setFontSize(12);
                doc.setFontSize(24);
                doc.setTextColor(34, 100, 174);
                doc.setFont(undefined, 'bold');
                //assegno l'ID dei Corsi_Presenze
                QRCode.toDataURL(
                    `${presenze[i].ID}`,
                    opts,
                    function (err, url) {
                        if (err) throw err;
                        qrcode.src = url;
                        doc.addImage(qrcode, 'JPEG', 33, 107, 50, 50);
                    }
                );
                doc.text('ATTESTATO DI PARTECIPAZIONE', 33, 195);
                doc.setFontSize(12);
                doc.setTextColor(0, 0, 0);
                doc.text(
                    doc.splitTextToSize(
                        `${corsiAttestati[0].Attestato1}`,
                        doc.internal.pageSize.getWidth() - 150
                    ),
                    33,
                    215
                );
                doc.text('Si attesta che:', 33, 265);
                doc.setFontSize(16);
                doc.setTextColor(34, 100, 174);

                //massimo 28 lettere se no spezzo

                doc.text(
                    presenze[i].Nome
                        ? cap(presenze[i].Nome.split(' ')) +
                              ' ' +
                              (presenze[i].Cognome
                                  ? cap(presenze[i].Cognome.split(' '))
                                  : '')
                        : presenze[i].Cognome
                          ? cap(presenze[i].Cognome.split(' '))
                          : '',
                    33,
                    290
                );
                doc.setFontSize(10);
                doc.setTextColor(0, 0, 0);
                doc.text('CF: ', 33, 310);
                doc.setFont(undefined, 'normal');
                doc.text(documentCfValue(presenze[i]), 52, 310);
                doc.setFont(undefined, 'bold');
                doc.text('LUOGO DI NASCITA: ', 33, 325);
                doc.setFont(undefined, 'normal');
                doc.text(
                    presenze[i].LuogoDiNascita
                        ? presenze[i].LuogoDiNascita
                        : '',
                    136,
                    325
                );
                doc.setFont(undefined, 'bold');
                doc.text('DATA DI NASCITA: ', 33, 340);
                doc.setFont(undefined, 'normal');
                doc.text(
                    presenze[i].DataDiNascita
                        ? moment(presenze[i].DataDiNascita).format('DD/MM/YYYY')
                        : '',
                    127,
                    340
                );

                doc.setFont(undefined, 'bold');
                doc.text(
                    `HA PARTECIPATO E SUPERATO LE PROVE FINALI DEL CORSO${
                        corsoH.Aggiornamento === 1 ? ' DI AGGIORNAMENTO' : ''
                    }:`,
                    33,
                    365
                );
                doc.setFontSize(14);
                doc.setTextColor(34, 100, 174);
                doc.text(
                    doc.splitTextToSize(
                        `${corsiAttestati[0].Attestato2.toUpperCase()}` ||
                            corsoH.Descrizione,
                        doc.internal.pageSize.getWidth() - 50
                    ),
                    33,
                    385
                );

                doc.setFontSize(10);
                doc.setTextColor(0, 0, 0);
                if (totaleOre) {
                    doc.text('MONTE ORE FREQUENTATO: ', 33, 425);
                    doc.setFont(undefined, 'normal');
                    doc.text(totaleOre + ' ORE', 178, 425);
                }
                doc.setFont(undefined, 'bold');
                if (presenze[i].CodiceATECO) {
                    doc.text('SETTORE DI RIFERIMENTO: ', 33, 440);
                    doc.setFont(undefined, 'normal');
                    doc.text(
                        presenze[i].CodiceATECO ? presenze[i].CodiceATECO : '',
                        170,
                        440
                    );
                }
                doc.setFont(undefined, 'bold');
                if (corsoH.Modalita !== 2) {
                    doc.text('IL SOGGETTO ORGANIZZATORE:', 33, 455);
                    doc.setFont(undefined, 'normal');
                    doc.text(presenze[i].RagioneSociale, 198, 455);
                    doc.setFont(undefined, 'bold');

                    if (
                        `${formatore?.Nome ?? ''} ${formatore?.Cognome ?? ''}`.trim()
                    ) {
                        doc.text('IL SOGGETTO FORMATORE:', 33, 470);
                        doc.setFont(undefined, 'normal');
                        doc.text(
                            `${formatore?.Nome} ${formatore?.Cognome}`,
                            175,
                            470
                        );
                    }

                }
                doc.setFont(undefined, 'bold');
                doc.text('SEDE/MODALITÀ DI EROGAZIONE DEL CORSO:', 33, 485);
                doc.setFont(undefined, 'normal');
                const modalitaDescrizione = (
                    modalita?.Descrizione ||
                    corsoH?.ModalitaDescrizione ||
                    ''
                )
                    .toString()
                    .toLowerCase();
                let luogo = modalitaDescrizione.includes('videoconferenza')
                    ? 'VIDEOCONFERENZA'
                    : modalitaDescrizione.includes('online') ||
                        modalitaDescrizione.includes('e-learning') ||
                        modalitaDescrizione.includes('elearning')
                      ? 'E-LEARNING'
                      : corsoH.Luogo === null
                        ? 'FRANCOLINO DI MEDIGLIA'
                        : corsoH.Luogo;
                doc.text(luogo, 265, 485);
                doc.setFont(undefined, 'bold');
                doc.text('PERIODO DI SVOLGIMENTO DEL CORSO: ', 33, 500);
                doc.setFont(undefined, 'normal');

                doc.text(
                    `${presenze[i].attestatoPeriod.startText} - ${presenze[i].attestatoPeriod.endText}`,
                    237,
                    500
                );

                /* test azzurro chiaro */
                doc.setTextColor(141, 196, 235);

                doc.text(
                    doc.splitTextToSize(
                        `${corsiAttestati[0].Attestato3}`,
                        doc.internal.pageSize.getWidth() - 200
                    ),
                    200,
                    565
                );

                if (corsoH.Modalita !== 2) {
                    if (formatore?.Nome || formatore?.Cognome || formatore?.Firma) {
                    if (formatore?.Nome || formatore?.Cognome || formatore?.Firma) {
                        doc.setTextColor(0, 0, 0);
                        var title = 'IL FORMATORE',
                            xOffset =
                                doc.internal.pageSize.width / 2 -
                                (doc.getStringUnitWidth(title) *
                                    doc.internal.getFontSize()) /
                                    2;
                        doc.text(title, xOffset, 635);
                    }
                    }

                    doc.setTextColor(0, 0, 0);
                    var title2 = 'IL SOGGETTO ORGANIZZATORE',
                        xOffset2 =
                            20 +
                            doc.internal.pageSize.width / 2 +
                            doc.internal.pageSize.width / 4 -
                            (doc.getStringUnitWidth(title2) *
                                doc.internal.getFontSize()) /
                                2;
                    doc.text(title2, xOffset2, 635);
                    doc.setTextColor(0, 0, 0);
                    doc.text(presenze[i].RagioneSociale, xOffset2, 650);

                    if (formatore) {
                        var title1 = `${formatore.Nome} ${formatore.Cognome}`;
                        xOffset =
                            doc.internal.pageSize.width / 2 -
                            (doc.getStringUnitWidth(title1) *
                                doc.internal.getFontSize()) /
                                2;
                        doc.text(title1, xOffset, 650);
                    }
                }
                if (i !== presenze.length - 1) {
                    doc.addPage();
                }
            }
                openPdf(doc, buildAttestatiFilename());

                const generatedPages =
                    doc.getNumberOfPages?.() ||
                    doc.internal?.getNumberOfPages?.() ||
                    doc.internal?.pages?.length - 1 ||
                    0;
                if (generatedPages !== presenze.length) {
                    props.setSnack({
                        severity: 'error',
                        messaggio:
                            'Errore nella generazione: pagine PDF non corrispondono ai presenti',
                    });
                    props.setOpenSnack(true);
                    return;
                }

                const filePdf = doc.output('datauristring').split('base64,')[1];

                try {
                    await unsplash.post(
                        `/corsi`,
                        {
                            filePdf: filePdf,
                            upload: true,
                            presenze: presenze,
                            corsoH: props.corsoH,
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                            },
                        }
                    );

                    props.setSnack({
                        severity: 'success',
                        messaggio:
                            'Generati attestati per i lavoratori presenti, e associati con successo',
                    });
                    props.setOpenSnack(true);
                } catch (error) {
                    console.error('Errore associazione attestati', error);
                    props.setSnack({
                        severity: 'error',
                        messaggio:
                            "Errore durante l'associazione degli attestati. Riprovare o contattare il supporto.",
                    });
                    props.setOpenSnack(true);
                }
            } finally {
                endCertProgress();
            }
        } else {
            props.setSnack({
                severity: 'warning',
                messaggio:
                    'Nessun lavoratore presente al corso, per favore segna prima le presenze',
            });
            props.setOpenSnack(true);
        }
        //oggetto,
        ///testo,
        //id: preventivoSel.id_client,

        //oggetto,
        ///testo,
        //id: preventivoSel.id_client,
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                </Grid>
            </GridToolbarContainer>
        );
    }

    return (
        <>
            <IconButton
                style={{ display: props.Operation !== 'Edit' ? 'None' : '' }}
                aria-label="edit"
                onClick={handleClickOpen}
                id={props.id}
            >
                <Edit
                    style={{ height: '2rem', width: '2rem', color: '#2265B1' }}
                />
            </IconButton>
            <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    style={{
                        display: props.Operation === 'Edit' ? 'None' : '',
                    }}
                    id={props.id}
                    variant="contained"
                    className="ButtonMiller"
                    onClick={handleClickOpen}
                    startIcon={<Add />}
                >
                    Aggiungi
                </Button>
            </Grid>
            <Dialog
                fullWidth={true}
                open={open}
                onClose={handleClose}
                maxWidth="xl"
                style={{ display: hideDialog ? 'none' : 'block' }}
                TransitionComponent={Transition}
            >
                <DialogTitle>
                    <Typography component="span" variant="h6" sx={{ textAlign: 'center', width: '100%' }}>
                        {props.Title}
                    </Typography>
                </DialogTitle>

                <Grid container spacing={2} px={3}>
                    {operation === 'Edit' &&
                        corsiR?.length > 0 &&
                            corsoH?.Modalita === 2 && (
                            <Grid item xs={12} style={{ textAlign: 'right' }}>
                                <Typography component="div" variant="h5">
                                    Data creazione edizione online{' '}
                                    {moment(corsiR[0].Data).format(
                                        'DD/MM/YYYY'
                                    )}
                                </Typography>
                            </Grid>
                        )}
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Nome edizione"
                            value={corsoH.NomeEdizione ?? ''}
                            onChange={(e) => {
                                setCorsoH({
                                    ...corsoH,
                                    NomeEdizione: e.target.value,
                                });
                                setUpdated(true);
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Autocomplete
                            id="combo-box-demo"
                            options={props.Modalita}
                            getOptionLabel={(option) => option.Descrizione}
                            fullWidth
                            value={modalita}
                            onChange={(event, newValue) => {
                                let c = { ...corsoH };
                                c.Modalita = newValue.ID ? newValue.ID : null;
                                setCorsoH(c);
                                setModalita(newValue);

                                setUpdated(true);
                                //setMedicoSel(newValue);
                                //handleChangeCliente(newValue);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    label="Modalità"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Autocomplete
                            id="combo-box-demo"
                            options={
                                modalita?.ID === 2
                                    ? props.Corsi.filter(
                                          (el) =>
                                              el.IDCorsoPiGreco !== null &&
                                              el.DisponibilePigreco
                                      )
                                    : props.Corsi.filter(
                                          (el) => el.IDCorsoPiGreco == null
                                      )
                            }
                            getOptionLabel={(option) =>
                                option.Codice + ' - ' + option.Descrizione
                            }
                            value={codiceCorso}
                            fullWidth
                            onChange={(event, newValue) => {
                                let c = { ...corsoH };
                                c.Tipo = newValue.Codice
                                    ? newValue.Codice
                                    : null;
                                c.Descrizione = newValue.Descrizione;
                                setCorsoH(c);
                                setCodiceCorso(newValue);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    label="Corso"
                                />
                            )}
                            disabled={operation === 'Edit' || !modalita}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <Autocomplete
                            id="combo-box-demo"
                            options={props.Formatori}
                            getOptionLabel={(option) =>
                                option.Nome + ' ' + option.Cognome
                            }
                            value={formatore}
                            fullWidth
                            onChange={(event, newValue) => {
                                let c = { ...corsoH };
                                c.Formatore = newValue.ID ? newValue.ID : null;
                                c.NomeFormatore =
                                    newValue.Nome + ' ' + newValue.Cognome;
                                setCorsoH(c);
                                setFormatore(newValue);
                                setUpdated(true);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    label="Formatore"
                                />
                            )}
                            disabled={!modalita || modalita?.ID === 2}
                            className="mb-2"
                        />
                        <NewFromatori
                            id="new"
                            saveFunction={handleSaveNuovoFormatore}
                            title="Nuovo Formatore"
                            buttonLabel="Nuovo Formatore"
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label="Luogo"
                            value={corsoH.Luogo ?? ''}
                            onChange={(e) => {
                                let c = { ...corsoH };
                                c.Luogo = e.target.value;
                                setCorsoH(c);
                                setUpdated(true);
                            }}
                            disabled={!modalita || modalita?.ID === 2}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            type="number"
                            label="Posti Totali"
                            value={corsoH.PostiTotali ?? ''}
                            onChange={(e) => {
                                let c = { ...corsoH };
                                c.PostiTotali = e.target.value;
                                setCorsoH(c);
                                setUpdated(true);
                            }}
                            disabled={!modalita || modalita?.ID === 2}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label="Note"
                            value={corsoH.Note ?? ''}
                            onChange={(e) => {
                                let c = { ...corsoH };
                                c.Note = e.target.value;
                                setCorsoH(c);
                                setUpdated(true);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} textAlign="center">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="GestioneMedicina"
                                    checked={
                                        corsoH.Aggiornamento === 1
                                            ? true
                                            : false
                                    }
                                    onChange={(e) => {
                                        let c = { ...corsoH };
                                        c.Aggiornamento = e.target.checked
                                            ? 1
                                            : 0;
                                        setCorsoH(c);
                                        setUpdated(true);
                                    }}
                                />
                            }
                            label="Aggiornamento"
                        />
                    </Grid>
                    {props.isEdizioneModal && (
                        <AddAllegatiInput
                            onFilesChange={(newFiles, sharedNames) => {
                                setFiles(newFiles);
                                setSharedFileNames(sharedNames || []);
                            }}
                            edizioneId={idCorso ?? corsoH.ID}
                            isEditMode={operation === 'Edit'}
                        />
                    )}

                    {operation === 'Edit' ? (
                        <>
                            <Grid
                                container
                                direction="row"
                                spacing={2}
                                alignItems="center"
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    m: 0,
                                }}
                            >
                                <Grid
                                    item
                                    xs={8}
                                    sx={{
                                        p: 0,
                                        alignItems: 'center',
                                        display: 'flex',
                                        gap: 1,
                                    }}
                                >
                                    {corsiR.length > 0 ? (
                                        <DialogGestionePartecipanti
                                            idCorso={idCorso}
                                            ModalitaFatturazioneCorsi={
                                                props.ModalitaFatturazioneCorsi
                                            }
                                            clienti={clienti}
                                            tipoCorso={corsoH.Tipo}
                                            modalita={corsoH.Modalita}
                                            edizione={corsoH.IdEdizionePigreco}
                                            corsiR={corsiR}
                                            handleLoadPresenze={
                                                handleLoadPresenze
                                            }
                                            handleLoadRighe={handleLoadRighe}
                                            partecipanti={
                                                corsiPresenze?.length > 0
                                                    ? corsiPresenze[0]
                                                    : []
                                            }
                                            loading={loadingPres}
                                            corsiPresenze={corsiPresenze}
                                            snack={props.snack}
                                            openSnack={props.openSnack}
                                            handleCloseSnack={
                                                props.handleCloseSnack
                                            }
                                            setSnack={props.setSnack}
                                            setOpenSnack={props.setOpenSnack}
                                            hideDialog={() =>
                                                setHideDialog(!hideDialog)
                                            }
                                            onFollowupCreated={async (
                                                payload
                                            ) => {
                                                const nuovaAula =
                                                    payload?.corsoH;
                                                if (!nuovaAula?.ID) {
                                                    return;
                                                }

                                                setCorsoH((current) => ({
                                                    ...current,
                                                    ...nuovaAula,
                                                    Formatore:
                                                        nuovaAula.IDFormatore ||
                                                        nuovaAula.Formatore ||
                                                        null,
                                                }));
                                                setIdCorso(nuovaAula.ID);
                                                setCodiceCorso(
                                                    props.Corsi.filter(
                                                        (p) =>
                                                            p.Codice ===
                                                            nuovaAula.Tipo
                                                    )[0]
                                                );
                                                setCorsiPresenze([[]]);
                                                await handleLoadRighe(
                                                    nuovaAula.ID
                                                );
                                                await handleLoadClientiCorso(
                                                    nuovaAula.ID
                                                );
                                                props.reloadCorsi();
                                            }}
                                            postiTot={corsoH.PostiTotali}
                                            postiRim={postiRimanenti}
                                        />
                                    ) : (
                                        ''
                                    )}
                                    <Dialog
                                        open={openReport}
                                        onClose={handleCloseReport}
                                        fullWidth={true}
                                        maxWidth="md"
                                        TransitionComponent={Transition}
                                    >
                                        {/* Title Container */}
                                        <DialogTitle
                                            sx={{
                                                mx: 'auto',
                                            }}
                                        >
                                            Errore invio Report
                                        </DialogTitle>
                                        {/* Body Container */}
                                        <DialogContent className="w-full h-full overflow-auto max-h-60 md:max-h-96 ">
                                            <>
                                                <Accordion
                                                    expanded={
                                                        expanded === 'panel1'
                                                    }
                                                    onChange={handleChange(
                                                        'panel1'
                                                    )}
                                                >
                                                    <AccordionSummary
                                                        expandIcon={
                                                            <ExpandMoreIcon
                                                                sx={{
                                                                    color: 'whitesmoke',
                                                                }}
                                                            />
                                                        }
                                                        aria-controls="panel2bh-content"
                                                        id="panel2bh-header"
                                                    >
                                                        <Typography
                                                            sx={{
                                                                width: '40%',
                                                            }}
                                                        >
                                                            Indirizzi email
                                                            mancanti per:
                                                        </Typography>
                                                        <b
                                                            style={{
                                                                width: '5%',
                                                            }}
                                                        >
                                                            {
                                                                missingEmail.length
                                                            }
                                                        </b>
                                                        {missingEmail.length !==
                                                        0 ? (
                                                            <Circle
                                                                sx={{
                                                                    color: '#FF2768',
                                                                }}
                                                            >
                                                                {' '}
                                                            </Circle>
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        {missingEmail?.map(
                                                            (el, index) => (
                                                                <div
                                                                    key={index}
                                                                >
                                                                    -
                                                                    <b>
                                                                        {el?.nome
                                                                            ? el.nome
                                                                            : ''}{' '}
                                                                        {el?.cognome
                                                                            ? el.cognome
                                                                            : ''}
                                                                    </b>
                                                                </div>
                                                            )
                                                        )}
                                                    </AccordionDetails>
                                                </Accordion>
                                            </>
                                        </DialogContent>
                                        <DialogActions
                                            xs={12}
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                mx: 2,
                                            }}
                                        >
                                            <Button
                                                onClick={handleCloseReport}
                                                variant="contained"
                                                className="ButtonMiller"
                                                startIcon={<Close />}
                                            >
                                                Chiudi
                                            </Button>
                                            {/* <>
              {excelDataMissingId.length === 0 ? (
                <Button
                  onClick={beforeSave}
                  variant="contained"
                  className="ButtonMiller"
                  startIcon={<Check />}
                >
                  Salva
                </Button>
              ) : (
                <></>
              )}
            </> */}
                                        </DialogActions>
                                    </Dialog>

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 2,
                                            flexWrap: 'wrap',
                                        }}
                                    >
                                        <ButtonGroup
                                            variant="contained"
                                            className="ButtonMiller"
                                            ref={anchorRef}
                                            aria-label="split button"
                                        >
                                            <Button
                                                startIcon={<PrintIcon />}
                                                variant="contained"
                                                className="ButtonMiller"
                                                onClick={() => {
                                                    handleToggleButton();
                                                }}
                                            >
                                                STAMPA
                                            </Button>

                                            <Button
                                                variant="contained"
                                                className="ButtonMiller"
                                                size="small"
                                                aria-controls={
                                                    openButton
                                                        ? 'split-button-menu'
                                                        : undefined
                                                }
                                                aria-expanded={
                                                    openButton ? 'true' : undefined
                                                }
                                                aria-label="select merge strategy"
                                                aria-haspopup="menu"
                                                onClick={() => {
                                                    handleToggleButton();
                                                }}
                                            >
                                                {openButton ? (
                                                    <ArrowDropUp />
                                                ) : (
                                                    <ArrowDropDownIcon />
                                                )}
                                            </Button>
                                        </ButtonGroup>
                                        <Button
                                            variant="contained"
                                            className="ButtonMillerTextWhite"
                                            startIcon={<Upload />}
                                            onClick={handleOpenBulkImport}
                                        >
                                            Importa attestati
                                        </Button>
                                        {certProgress.total > 0 && (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                    minWidth: 200,
                                                }}
                                            >
                                                <LinearProgress
                                                    variant="determinate"
                                                    value={
                                                        (certProgress.current /
                                                            certProgress.total) *
                                                        100
                                                    }
                                                    sx={{ flex: 1 }}
                                                />
                                                <Typography
                                                    variant="caption"
                                                    color="text.secondary"
                                                >
                                                    {certProgress.current}/
                                                    {certProgress.total}
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                    <Popper
                                        sx={{
                                            zIndex: 100,
                                        }}
                                        open={openButton}
                                        anchorEl={anchorRef.current}
                                        role={undefined}
                                        transition
                                        disablePortal
                                    >
                                        {({ TransitionProps, placement }) => (
                                            <Grow {...TransitionProps}>
                                                <Paper sx={{ ml: '70px' }}>
                                                    <ClickAwayListener
                                                        onClickAway={
                                                            handleCloseButton
                                                        }
                                                    >
                                                        <MenuList
                                                            id="split-button-menu"
                                                            autoFocusItem
                                                        >
                                                            {(corsoH?.Modalita !==
                                                            2
                                                                ? options
                                                                : [
                                                                      options[0],
                                                                      options[3],
                                                                  ]
                                                            ).map(
                                                                (
                                                                    option,
                                                                    index
                                                                ) => (
                                                                    <MenuItem
                                                                        key={
                                                                            index
                                                                        }
                                                                        disabled={
                                                                            corsoH.Modalita ===
                                                                                2 &&
                                                                            !corsiPresenze?.[0]?.filter(
                                                                                (
                                                                                    p,
                                                                                    index
                                                                                ) =>
                                                                                    p.perc_course ===
                                                                                    100
                                                                            )
                                                                                ?.length
                                                                        }
                                                                        selected={
                                                                            index ===
                                                                            selectedIndex
                                                                        }
                                                                        onClick={(
                                                                            event
                                                                        ) => {
                                                                            if (
                                                                                corsoH.Modalita ===
                                                                                2
                                                                            ) {
                                                                                handleMenuItemClick(
                                                                                    event,
                                                                                    index ===
                                                                                        1
                                                                                        ? 3
                                                                                        : index
                                                                                );
                                                                            } else {
                                                                                handleMenuItemClick(
                                                                                    event,
                                                                                    index
                                                                                );
                                                                            }
                                                                        }}
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                color: '#11526f',
                                                                            }}
                                                                        >
                                                                            {
                                                                                option.icon
                                                                            }{' '}
                                                                            {
                                                                                option.text
                                                                            }
                                                                        </span>
                                                                    </MenuItem>
                                                                )
                                                            )}
                                                        </MenuList>
                                                    </ClickAwayListener>
                                                </Paper>
                                            </Grow>
                                        )}
                                    </Popper>
                                    <div style={{ display: 'none' }}>
                                        <Button
                                            id="0"
                                            variant="contained"
                                            className="ButtonMiller"
                                            onClick={() => {
                                                if (updated) {
                                                    handleCourseCreation();
                                                }
                                                if (
                                                    !corsoH.Formatore &&
                                                    corsoH?.Modalita !== 2
                                                ) {
                                                    props.setSnack({
                                                        severity: 'error',
                                                        messaggio:
                                                            'Seleziona il formatore del corso',
                                                    });
                                                    props.setOpenSnack(true);
                                                } else {
                                                    exportPDF('all');
                                                }
                                            }}
                                            sx={{
                                                display: stampa
                                                    ? 'flex'
                                                    : 'none',
                                            }}
                                        >
                                            STAMPA TUTTI GLI ATTESTATI
                                        </Button>

                                        <Button
                                            id="1"
                                            variant="contained"
                                            className="ButtonMiller"
                                            sx={{
                                                display:
                                                    operation === 'Edit'
                                                        ? ''
                                                        : 'None',
                                            }}
                                            onClick={() => {
                                                if (
                                                    !corsiR[0].Durata &&
                                                    !corsiR[0].Ora
                                                ) {
                                                    props.setSnack({
                                                        severity: 'error',
                                                        messaggio:
                                                            "Aggiungi l'ora e la durata del corso",
                                                    });
                                                    props.setOpenSnack(true);
                                                } else if (!corsiR[0].Durata) {
                                                    props.setSnack({
                                                        severity: 'error',
                                                        messaggio:
                                                            'Aggiungi la durata del corso',
                                                    });
                                                    props.setOpenSnack(true);
                                                } else if (!corsiR[0].Ora) {
                                                    props.setSnack({
                                                        severity: 'error',
                                                        messaggio:
                                                            "Aggiungi l'ora del corso",
                                                    });
                                                    props.setOpenSnack(true);
                                                } else if (!corsoH.Formator) {
                                                    props.setSnack({
                                                        severity: 'error',
                                                        messaggio:
                                                            'Seleziona il formatore del corso',
                                                    });
                                                    props.setOpenSnack(true);
                                                } else if (
                                                    giornoSel?.length !== 1
                                                ) {
                                                    props.setSnack({
                                                        severity: 'error',
                                                        messaggio:
                                                            'Seleziona solo un giorno',
                                                    });
                                                    props.setOpenSnack(true);
                                                } else {
                                                    if (updated) {
                                                        handleCourseCreation();
                                                    }
                                                    exportPDFPartecipanti(
                                                        '',
                                                        corsiR[0],
                                                        corsiPresenze[0],
                                                        props.corsoH
                                                            ? props.corsoH
                                                            : corsoH
                                                    );
                                                }
                                            }}
                                        >
                                            REGISTRO CONSEGNE
                                        </Button>
                                        <Button
                                            id="2"
                                            variant="contained"
                                            className="ButtonMiller"
                                            sx={{
                                                display:
                                                    operation === 'Edit'
                                                        ? ''
                                                        : 'None',
                                            }}
                                            onClick={() => {
                                                if (
                                                    !corsiR[0].Durata &&
                                                    !corsiR[0].Ora
                                                ) {
                                                    props.setSnack({
                                                        severity: 'error',
                                                        messaggio:
                                                            "Aggiungi l'ora e la durata del corso",
                                                    });
                                                    props.setOpenSnack(true);
                                                } else if (!corsiR[0].Durata) {
                                                    props.setSnack({
                                                        severity: 'error',
                                                        messaggio:
                                                            'Aggiungi la durata del corso',
                                                    });
                                                    props.setOpenSnack(true);
                                                } else if (!corsiR[0].Ora) {
                                                    props.setSnack({
                                                        severity: 'error',
                                                        messaggio:
                                                            "Aggiungi l'ora del corso",
                                                    });
                                                    props.setOpenSnack(true);
                                                } else if (corsoH.Formatore) {
                                                    if (updated) {
                                                        handleCourseCreation();
                                                    }
                                                    exportPDFPresenze(
                                                        'all',
                                                        corsiR[0],
                                                        corsiPresenze[0],
                                                        props.corsoH
                                                            ? props.corsoH
                                                            : corsoH
                                                    );
                                                } else {
                                                    props.setSnack({
                                                        severity: 'error',
                                                        messaggio:
                                                            'Seleziona il formatore del corso',
                                                    });
                                                    props.setOpenSnack(true);
                                                }
                                            }}
                                        >
                                            REGISTRO PRESENZE
                                        </Button>
                                        <Button
                                            id="3"
                                            variant="contained"
                                            className="ButtonMiller"
                                            onClick={() =>
                                                exportPDFwithAssociation('all')
                                            }
                                            sx={{
                                                display: stampa
                                                    ? 'flex'
                                                    : 'none',
                                            }}
                                        >
                                            STAMPA E ASSOCIA
                                        </Button>
                                    </div>

                                    {giornoSel?.length > 0 ? (
                                        <ButtonGroup
                                            variant="contained"
                                            className="ButtonMiller"
                                            ref={anchorRefReport}
                                            aria-label="split button"
                                        >
                                            <Button
                                                startIcon={<Email />}
                                                variant="contained"
                                                className="ButtonMiller"
                                                onClick={() => {
                                                    handleToggleButtonReport();
                                                }}
                                            >
                                                CONVOCAZIONE
                                            </Button>
                                            <Button
                                                variant="contained"
                                                className="ButtonMiller"
                                                size="small"
                                                aria-controls={
                                                    openButtonReport
                                                        ? 'split-button-menu'
                                                        : undefined
                                                }
                                                aria-expanded={
                                                    openButtonReport
                                                        ? 'true'
                                                        : undefined
                                                }
                                                aria-label="select merge strategy"
                                                aria-haspopup="menu"
                                                onClick={() => {
                                                    handleToggleButtonReport();
                                                }}
                                            >
                                                {openButtonReport ? (
                                                    <ArrowDropUp />
                                                ) : (
                                                    <ArrowDropDownIcon />
                                                )}
                                            </Button>
                                        </ButtonGroup>
                                    ) : (
                                        ''
                                    )}

                                    <Popper
                                        sx={{
                                            zIndex: 100,
                                        }}
                                        open={openButtonReport}
                                        anchorEl={anchorRefReport.current}
                                        role={undefined}
                                        transition
                                        disablePortal
                                    >
                                        {({ TransitionProps, placement }) => (
                                            <Grow {...TransitionProps}>
                                                <Paper sx={{ ml: '10px' }}>
                                                    <ClickAwayListener
                                                        onClickAway={
                                                            handleCloseButtonReport
                                                        }
                                                    >
                                                        <MenuList
                                                            id="split-button-menu"
                                                            autoFocusItem
                                                        >
                                                            {optionsReport.map(
                                                                (
                                                                    option,
                                                                    index
                                                                ) => (
                                                                    <MenuItem
                                                                        key={
                                                                            option
                                                                        }
                                                                        selected={
                                                                            option.ind ===
                                                                            selectedIndexReport
                                                                        }
                                                                        onClick={(
                                                                            event
                                                                        ) => {
                                                                            handleMenuItemClickReport(
                                                                                event,
                                                                                option.ind
                                                                            );
                                                                        }}
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                color: '#11526f',
                                                                            }}
                                                                        >
                                                                            {
                                                                                option.icon
                                                                            }{' '}
                                                                            {
                                                                                option.text
                                                                            }
                                                                        </span>
                                                                    </MenuItem>
                                                                )
                                                            )}
                                                        </MenuList>
                                                    </ClickAwayListener>
                                                </Paper>
                                            </Grow>
                                        )}
                                    </Popper>
                                    <div style={{ display: 'none' }}>
                                        <Button
                                            id="4"
                                            variant="contained"
                                            className="ButtonMiller"
                                            onClick={() => {
                                                if (giornoSel?.length === 0) {
                                                    props.setSnack({
                                                        severity: 'error',
                                                        messaggio:
                                                            'Seleziona un giorno',
                                                    });
                                                    props.setOpenSnack(true);
                                                } else {
                                                    hadleReport(
                                                        'dipendenti',
                                                        giornoSel,
                                                        corsiPresenze[0]
                                                    );
                                                }
                                            }}
                                        >
                                            Dipendente
                                        </Button>

                                        <Button
                                            id="5"
                                            variant="contained"
                                            className="ButtonMiller"
                                            sx={{
                                                display:
                                                    operation === 'Edit'
                                                        ? ''
                                                        : 'None',
                                            }}
                                            onClick={() => {
                                                if (giornoSel?.length === 0) {
                                                    props.setSnack({
                                                        severity: 'error',
                                                        messaggio:
                                                            'Seleziona un giorno',
                                                    });
                                                    props.setOpenSnack(true);
                                                } else {
                                                    hadleReport(
                                                        'referenti',
                                                        giornoSel,
                                                        corsiPresenze[0]
                                                    );
                                                }
                                            }}
                                        >
                                            Referenti
                                        </Button>
                                    </div>
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        gap: 5,
                                    }}
                                >
                                    {corsoH?.Modalita !== 2 ? (
                                        <>
                                            <DialogGestioneDateCorsi
                                                Title="Aggiungi Giornata"
                                                operation="Nuovo"
                                                idCorso={idCorso}
                                                formatore={formatore?.ID}
                                                handleLoadRighe={
                                                    handleLoadRighe
                                                }
                                                snack={props.snack}
                                                openSnack={props.openSnack}
                                                handleCloseSnack={
                                                    props.handleCloseSnack
                                                }
                                                setSnack={props.setSnack}
                                                setOpenSnack={
                                                    props.setOpenSnack
                                                }
                                            />
                                        </>
                                    ) : null}
                                </Grid>
                            </Grid>
                        </>
                    ) : (
                        ''
                    )}
                    {corsoH?.Modalita !== 2 && operation === 'Edit' && (
                        <Box
                            sx={{
                                height: 300,
                                width: 1,
                                marginTop: '10px',
                                marginLeft: '16px',
                            }}
                        >
                            <DataGridPro
                                initialState={{
                                    pinnedColumns: { left: ['Actions'] },
                                }}
                                sx={{ fontSize: 12 }}
                                components={{
                                    Toolbar: CustomToolbar,
                                    Footer: CustomFooterPersonalized,
                                }}
                                slots={{
                                    loadingOverlay: LinearProgress,
                                }}
                                loading={loading}
                                localeText={
                                    itIT.components.MuiDataGrid.defaultProps
                                        .localeText
                                }
                                disableRowSelectionOnClick
                                rows={corsiR}
                                columns={columnsOre}
                                getRowId={(row) => row.ID}
                                onSelectionModelChange={(ids) => {
                                    const selectedIDs = new Set(ids);
                                    const selectedRowData = corsiR.filter(
                                        (row) => selectedIDs.has(row.ID)
                                    );

                                    setGiornoSel(selectedRowData);
                                }}
                                checkboxSelection
                                onCellClick={(params, e) => {
                                    if (params.field === 'Actions') {
                                        e.stopPropagation();
                                    }
                                }}
                            />
                        </Box>
                    )}
                    <Dialog
                        open={openPartecipanti}
                        onClose={handleClosePresenzeDialog}
                        fullWidth={true}
                        maxWidth="lg"
                        TransitionComponent={Transition}
                    >
                        <DialogTitle
                            sx={{
                                mx: 'auto',
                            }}
                        >
                            {giornoCorso.current}
                        </DialogTitle>
                        <DialogContent>
                            <Grid
                                container
                                item
                                xs={12}
                                sx={{
                                    display: 'flex',
                                    mt: 2,
                                    justifyContent: 'flex-end',
                                }}
                            >
                                    <Button
                                        variant="contained"
                                        className="ButtonMiller"
                                        sx={{
                                            color: '#fff',
                                            mt: 2,
                                            mr: 1,
                                        }}
                                        onClick={() =>
                                            handleToggleAllPresenze(
                                                bulkPresenceTarget === 1
                                            )
                                        }
                                        disabled={
                                            currentPresenzeRows.length === 0 ||
                                            savingPresenze
                                        }
                                    >
                                    {bulkPresenceLabel}
                                    </Button>
                                <ButtonGroup
                                    sx={{
                                        display: 'flex',
                                        mt: 2,
                                        pl: 2,
                                        flexWrap: 'nowrap',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        className="ButtonMiller"
                                        onClick={() => {
                                            if (!corsoH.Formatore) {
                                                props.setSnack({
                                                    severity: 'error',
                                                    messaggio:
                                                    'Seleziona il formatore del corso',
                                                });
                                                props.setOpenSnack(true);
                                            } else {
                                                exportPDF();
                                            }
                                        }}
                                        sx={{
                                            display: stampa ? 'flex' : 'none',
                                        }}
                                        startIcon={<Print />}
                                    >
                                        STAMPA ATTESTATO
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                            {corsiR.length > 0 ? (
                                corsiR.map((c, index) => {
                                    return (
                                        <TabPanel
                                            value={value}
                                            index={index}
                                            key={index}
                                        >
                                            <Box
                                                sx={{
                                                    height: 400,
                                                    width: 1,
                                                    marginTop: '10px',
                                                }}
                                            >
                                                <DataGridPro
                                                    sx={{
                                                        fontSize: 12,
                                                        '& .MuiDataGrid-row': {
                                                            cursor: 'pointer',
                                                        },
                                                    }}
                                                    localeText={
                                                        itIT.components
                                                            .MuiDataGrid
                                                            .defaultProps
                                                            .localeText
                                                    }
                                                    components={{
                                                        Toolbar: CustomToolbar,
                                                        Footer: CustomFooterPersonalized,
                                                    }}
                                                    slots={{
                                                        loadingOverlay:
                                                            LinearProgress,
                                                    }}
                                                    loading={loadingPres}
                                                    rows={
                                                        corsiPresenze
                                                            ? corsiPresenze[
                                                                  index
                                                              ]
                                                            : []
                                                    }
                                                    getRowId={(row) =>
                                                        Number(row.ID)
                                                    }
                                                    columns={columns}
                                                    pageSize={100}
                                                    checkboxSelection
                                                    selectionModel={
                                                        selectedPresenzeIds
                                                    }
                                                    disableSelectionOnClick
                                                    isRowSelectable={(params) =>
                                                        isPrintablePresenza(
                                                            params.row
                                                        )
                                                    }
                                                    onSelectionModelChange={(
                                                        ids
                                                    ) => {
                                                        logPresenzeGridInteraction(
                                                            'selectionModelChange',
                                                            {
                                                                ids,
                                                            }
                                                        );
                                                        syncAttestatiSelection(
                                                            ids,
                                                            corsiPresenze?.[
                                                                index
                                                            ] || []
                                                        );
                                                    }}
                                                    componentsProps={{
                                                        cell: {
                                                            onClick: (event) => {
                                                                logPresenzeGridInteraction(
                                                                    'cellClickCapture',
                                                                    {
                                                                        field:
                                                                            event
                                                                                ?.currentTarget
                                                                                ?.dataset
                                                                                ?.field,
                                                                        target:
                                                                            event
                                                                                ?.target
                                                                                ?.tagName,
                                                                    }
                                                                );
                                                            },
                                                            onMouseDown: (
                                                                event
                                                            ) => {
                                                                logPresenzeGridInteraction(
                                                                    'cellMouseDown',
                                                                    {
                                                                        field:
                                                                            event
                                                                                ?.currentTarget
                                                                                ?.dataset
                                                                                ?.field,
                                                                        target:
                                                                            event
                                                                                ?.target
                                                                                ?.tagName,
                                                                    }
                                                                );
                                                                if (
                                                                    event
                                                                        ?.currentTarget
                                                                        ?.dataset
                                                                        ?.field ===
                                                                    'presenza'
                                                                ) {
                                                                    event.stopPropagation();
                                                                }
                                                            },
                                                        },
                                                    }}
                                                    onCellClick={(
                                                        params,
                                                        event
                                                    ) => {
                                                        logPresenzeGridInteraction(
                                                            'onCellClick',
                                                            {
                                                                field: params.field,
                                                                rowId:
                                                                    params.row?.ID,
                                                                target:
                                                                    event
                                                                        ?.target
                                                                        ?.tagName,
                                                            }
                                                        );
                                                        event
                                                            ?.stopPropagation?.();

                                                        if (
                                                            params.field ===
                                                            'presenza'
                                                        ) {
                                                            return;
                                                        }

                                                        if (
                                                            params.field !==
                                                            '__check__'
                                                        ) {
                                                            toggleSelectedPresenzaId(
                                                                params.row?.ID,
                                                                corsiPresenze?.[
                                                                    index
                                                                ] || []
                                                            );
                                                        }
                                                    }}
                                                />
                                            </Box>
                                        </TabPanel>
                                    );
                                })
                            ) : (
                                <Box
                                    sx={{
                                        height: 400,
                                        width: 1,
                                        marginTop: '10px',
                                    }}
                                >
                                    <DataGridPro
                                        sx={{
                                            fontSize: 12,
                                            '& .MuiDataGrid-row': {
                                                cursor: 'pointer',
                                            },
                                        }}
                                        components={{
                                            Toolbar: CustomToolbar,
                                            Footer: CustomFooterPersonalized,
                                        }}
                                        checkboxSelection
                                        localeText={
                                            itIT.components.MuiDataGrid
                                                .defaultProps.localeText
                                        }
                                        rows={[]}
                                        getRowId={(row) => Number(row.ID)}
                                        columns={columns}
                                        pageSize={100}
                                        selectionModel={[]}
                                    />
                                </Box>
                            )}

                            <Grid container>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        mt: 2,
                                    }}
                                >
                                    <Button
                                        onClick={handleClosePresenzeDialog}
                                        variant="contained"
                                        className="ButtonMiller"
                                        startIcon={<Close />}
                                        disabled={savingPresenze}
                                    >
                                        Chiudi
                                    </Button>
                                    <Button
                                        onClick={handleSavePresenze}
                                        variant="contained"
                                        className="ButtonMillerTextWhite"
                                        sx={{
                                            '& .MuiButton-startIcon': {
                                                color: '#fff',
                                            },
                                        }}
                                        startIcon={
                                            savingPresenze ? null : <Check />
                                        }
                                        disabled={
                                            savingPresenze || !presenzeDirty
                                        }
                                    >
                                        {savingPresenze
                                            ? 'Salvataggio...'
                                            : 'Salva presenze'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </Dialog>
                </Grid>

                <DialogActions>
                    <Grid container>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                mt: 2,
                                p: 2,
                            }}
                        >
                            <Button
                                onClick={() => handleClose(true)}
                                variant="contained"
                                className="ButtonMiller"
                                startIcon={<Close />}
                            >
                                Chiudi
                            </Button>
                            <Button
                                className="ButtonMiller"
                                variant="contained"
                                onClick={handleCourseCreation}
                                startIcon={<Check />}
                            >
                                Salva
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <BulkAttestatiImportDialog
                open={openBulkImport}
                clienteId={bulkImportClienteId}
                corsoSel={{
                    Codice: corsoH.Tipo,
                    Descrizione: corsoH.Descrizione,
                }}
                onClose={() => {
                    setOpenBulkImport(false);
                }}
                onImported={() => {
                    handleLoadPresenze(corsiR, idCorso);
                    props.setSnack({
                        severity: 'success',
                        messaggio: 'Import massivo attestati completato',
                    });
                    props.setOpenSnack(true);
                }}
                handleShowSnack={(messaggio, severity = 'success') => {
                    props.setSnack({ severity, messaggio });
                    props.setOpenSnack(true);
                }}
            />
        </>
    );
};

export default DettaglioCorsi;

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>{children}</Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const DialogGestionePartecipanti = (props) => {
    const [lavoratoriTutti, setLavoratoriTutti] = useState([]); // Lista completa lavoratori per ricalcolo
    const [lavoratori, setLavoratori] = useState([]); // Lavoratori disponibili
    const [lavoratoriPartecipanti, setLavoratoriPartecipanti] = useState([]); // Lavoratori già partecipanti
    const [lavoratoriSelezionati, setLavoratoriSelezionati] = useState([]); // Lavoratori selezionati per spostamento
    const [participantSelectionModel, setParticipantSelectionModel] = useState(
        []
    );
    const [lavoratoriDaRimuovere, setLavoratoriDaRimuovere] = useState([]); // Lavoratori selezionati per rimozione
    const [lavoratoriDaAggiungere, setLavoratoriDaAggiungere] = useState([]); // Lavoratori da aggiungere al corso
    const [lavoratoriDaEliminare, setLavoratoriDaEliminare] = useState([]); // Lavoratori da rimuovere dal corso
    const [recentAddedParticipantIds, setRecentAddedParticipantIds] = useState(
        []
    );
    const [loading, setLoading] = useState(false);
    const [loadingPart, setLoadingPart] = useState(false);
    const [savingMovement, setSavingMovement] = useState(false);
    const [pigrecoEditionWarning, setPigrecoEditionWarning] = useState(null);
    const [existingValidFollowupCourse, setExistingValidFollowupCourse] =
        useState(null);
    const [creatingFollowupEdition, setCreatingFollowupEdition] =
        useState(false);
    const [migrationTargets, setMigrationTargets] = useState([]);
    const [migrationTargetId, setMigrationTargetId] = useState('');
    const [migratingParticipants, setMigratingParticipants] = useState(false);
    const [migrationDialogOpen, setMigrationDialogOpen] = useState(false);
    const [migrationPresenceIds, setMigrationPresenceIds] = useState([]);
    const [open, setOpen] = useState(false);
    const postiRimanenti = useRef(0);
    const getWorkerId = (row) => row?.Lavoratore ?? row?.ID ?? null;
    const clearPigrecoIdsFromRows = (rows, iscrizioni) => {
        if (!Array.isArray(rows) || rows.length === 0) {
            return rows;
        }
        const iscrizioniSet = new Set(
            (iscrizioni || []).map((value) => Number(value)).filter(Boolean)
        );
        if (iscrizioniSet.size === 0) {
            return rows;
        }
        return rows.map((row) =>
            iscrizioniSet.has(Number(row?.IDIscrizionePiGreco))
                ? { ...row, IDIscrizionePiGreco: null }
                : row
        );
    };

    const isCessato = (row) =>
        row?.DataTermine &&
        moment(row.DataTermine).isValid() &&
        moment(row.DataTermine).isSameOrBefore(moment(), 'day');
    const getPercCourse = (row) => {
        const value = Number(row?.perc_course);
        return Number.isFinite(value) ? value : 0;
    };
    const hasStartedOnPigreco = (row) =>
        props.modalita === 2 &&
        (getPercCourse(row) > 0 ||
            !!row?.date_start ||
            row?.status_course === 'CONCLUDED');
    const formatPigrecoEditionWarning = (subscribability) => {
        if (!subscribability || subscribability.subscribable !== false) {
            return null;
        }

        const reason = subscribability.reason;
        if (reason === 'INCOMPLETE_USERS_ALREADY_ENDED') {
            return `Edizione Pigreco conclusa: ${subscribability.affectedUsers || 0} partecipante/i risultano non completati ma con data completamento valorizzata. Non iscrivere nuovi partecipanti su questa edizione.`;
        }
        if (reason === 'INCOMPLETE_USERS_EXPIRED') {
            return `Edizione Pigreco scaduta: ${subscribability.affectedUsers || 0} partecipante/i non completati hanno termine massimo superato. Non iscrivere nuovi partecipanti su questa edizione.`;
        }
        if (reason === 'EDITION_EXPIRED') {
            return `Edizione Pigreco scaduta: ultimo termine massimo ${moment(subscribability.maxDateExpire).format('DD/MM/YYYY')}. Non iscrivere nuovi partecipanti su questa edizione.`;
        }
        if (reason === 'LOCAL_EDITION_OLDER_THAN_30_DAYS') {
            return `Edizione Pigreco probabilmente scaduta: aula creata il ${moment(subscribability.dataPrimaRiga).format('DD/MM/YYYY')}. Verificare prima di iscrivere nuovi partecipanti.`;
        }

        return 'Edizione Pigreco non utilizzabile per nuove iscrizioni. Verificare lo stato prima di proseguire.';
    };
    const prioritizeRecentParticipants = useCallback(
        (rows, priorityIds = recentAddedParticipantIds) => {
            if (
                !Array.isArray(rows) ||
                rows.length === 0 ||
                priorityIds.length === 0
            ) {
                return rows;
            }

            const priorityMap = new Map(
                priorityIds.map((id, index) => [Number(id), index])
            );

            return [...rows].sort((left, right) => {
                const leftPriority = priorityMap.get(Number(getWorkerId(left)));
                const rightPriority = priorityMap.get(
                    Number(getWorkerId(right))
                );

                if (leftPriority === undefined && rightPriority === undefined) {
                    return 0;
                }
                if (leftPriority === undefined) {
                    return 1;
                }
                if (rightPriority === undefined) {
                    return -1;
                }

                return leftPriority - rightPriority;
            });
        },
        [recentAddedParticipantIds]
    );
    const unsavedAddedParticipantIds = lavoratoriDaAggiungere
        .map((row) => Number(row?.ID ?? getWorkerId(row)))
        .filter(Boolean);
    const selectedPartecipantiIds = Array.from(
        new Set([
            ...unsavedAddedParticipantIds,
            ...participantSelectionModel.map(Number).filter(Boolean),
        ])
    );
    const selectedPartecipantiIdSet = new Set(selectedPartecipantiIds);
    const migrationEligibleParticipants = [
        ...lavoratoriPartecipanti
            .filter(
                (row) =>
                    row?.IDCorsoPresenza && row?.IDIscrizionePiGreco
                    && row?.pigrecoSourceEnrollmentVerified === true
            )
            .reduce((byWorker, row) => {
                const workerId = Number(getWorkerId(row));
                const rawCompletion = row?.perc_course;
                const completion =
                    rawCompletion === null ||
                    rawCompletion === undefined ||
                    rawCompletion === ''
                        ? NaN
                        : Number(rawCompletion);
                if (
                    workerId &&
                    Number.isFinite(completion) &&
                    completion < 100 &&
                    row?.status_course !== 'CONCLUDED'
                ) {
                    byWorker.set(workerId, row);
                }
                return byWorker;
            }, new Map())
            .values(),
    ];
    const isPigrecoEditionBlocked =
        props.modalita === 2 && Boolean(pigrecoEditionWarning);
    const buildDialogPartecipantiState = useCallback(
        (
            allWorkers = lavoratoriTutti,
            basePartecipanti = props.partecipanti,
            toAdd = lavoratoriDaAggiungere,
            toRemove = lavoratoriDaEliminare
        ) => {
            const baseMerged = mergePartecipanti(allWorkers, basePartecipanti);
            const pendingAdds = (toAdd || []).filter(
                (row) =>
                    !baseMerged.some(
                        (participant) =>
                            Number(getWorkerId(participant)) ===
                            Number(getWorkerId(row))
                    )
            );
            const removeIds = new Set(
                (toRemove || [])
                    .map((row) => Number(getWorkerId(row)))
                    .filter(Boolean)
            );

            const partecipanti = prioritizeRecentParticipants(
                [...baseMerged, ...pendingAdds].filter(
                    (row) => !removeIds.has(Number(getWorkerId(row)))
                )
            );
            const disponibili = getDifference(
                allWorkers,
                partecipanti,
                'ID',
                'ID'
            );

            return { partecipanti, disponibili };
        },
        [
            lavoratoriTutti,
            props.partecipanti,
            lavoratoriDaAggiungere,
            lavoratoriDaEliminare,
            prioritizeRecentParticipants,
        ]
    );

    const columns = [
        {
            field: 'Cessato',
            headerName: 'Cessato',
            flex: 0.5,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            renderCell: (params) =>
                isCessato(params.row) ? (
                    <Circle sx={{ color: '#D32F2F', fontSize: 12 }} />
                ) : (
                    ''
                ),
        },
        {
            field: 'Cognome',
            headerName: 'Cognome',
            //width: 400,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Nome',
            headerName: 'Nome',
            //width: 400,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Cliente',
            headerName: 'Azienda',
            //width: 400,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Scadenza',
            headerName: 'Scadenza',
            //width: 400,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.Scadenza
                            ? moment(new Date(params.row.Scadenza)).format(
                                  'DD/MM/YYYY'
                              )
                            : ''}
                    </div>
                );
            },
        },
    ];

    const handleClickOpen = async () => {
        setLoading(true);
        setLoadingPart(true);
        setLavoratoriDaAggiungere([]);
        setLavoratoriDaEliminare([]);
        setLavoratoriSelezionati([]);
        setLavoratoriDaRimuovere([]);
        setParticipantSelectionModel([]);
        setRecentAddedParticipantIds([]);
        setPigrecoEditionWarning(null);
        setExistingValidFollowupCourse(null);
        setCreatingFollowupEdition(false);
        setMigrationTargets([]);
        setMigrationTargetId('');
        setMigrationDialogOpen(false);
        setMigrationPresenceIds([]);
        props.hideDialog();
        setOpen(true);

        // Mostra subito i partecipanti già noti (deduplicati), poi completa la popolazione con i dati aggiornati.
        const partecipantiIniziali = mergePartecipanti([], props.partecipanti);
        setLavoratoriPartecipanti(partecipantiIniziali);
        postiRimanenti.current = props.postiTot - partecipantiIniziali.length;

        try {
            const headers = {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            };
            const [response, pigrecoStatusResponse] = await Promise.all([
                unsplash.get('dettaglioCorsi', {
                    params: {
                        tipologia: 'Lavoratori',
                        tipologiaCorso: props.tipoCorso,
                        currentCorsoHId: props.idCorso,
                        excludeAlreadyInvitedOtherEditions:
                            props.modalita === 2 ? 1 : 0,
                        excludeCompletedOtherEditions:
                            props.modalita === 2 ? 1 : 0,
                    },
                    headers,
                }),
                props.modalita === 2 && props.edizione
                    ? unsplash.post(
                          'pigreco/statusOfEdition',
                          { edizione: props.edizione },
                          { headers }
                      )
                    : Promise.resolve(null),
            ]);

            const warning = formatPigrecoEditionWarning(
                pigrecoStatusResponse?.data?.subscribability
            );
            setPigrecoEditionWarning(warning);
            setExistingValidFollowupCourse(
                pigrecoStatusResponse?.data?.existingValidFollowupCourse || null
            );
            const targets = Array.isArray(
                pigrecoStatusResponse?.data?.migrationTargets
            )
                ? pigrecoStatusResponse.data.migrationTargets
                : [];
            setMigrationTargets(targets);
            setMigrationTargetId('');

            const { partecipanti, disponibili } = buildDialogPartecipantiState(
                response.data.data,
                props.partecipanti,
                [],
                []
            );

            setLavoratoriTutti(response.data.data);
            setLavoratori(disponibili);
            setLavoratoriPartecipanti(partecipanti);

            postiRimanenti.current =
                props.postiTot - partecipanti.length;
        } catch (error) {
            console.error('Errore nel caricamento dei dati:', error);
        } finally {
            setLoading(false);
            setLoadingPart(false);
        }
    };

    useEffect(() => {
        if (!open || lavoratoriTutti.length === 0) {
            return;
        }
        const { partecipanti, disponibili } = buildDialogPartecipantiState(
            lavoratoriTutti,
            props.partecipanti,
            lavoratoriDaAggiungere,
            lavoratoriDaEliminare
        );
        setLavoratori(disponibili);
        setLavoratoriPartecipanti(partecipanti);
        postiRimanenti.current =
            props.postiTot - partecipanti.length;
    }, [
        open,
        lavoratoriTutti,
        props.partecipanti,
        props.postiTot,
        buildDialogPartecipantiState,
        lavoratoriDaAggiungere,
        lavoratoriDaEliminare,
    ]);

    const handleClose = () => {
        props.hideDialog();
        setRecentAddedParticipantIds([]);
        setOpen(false);
    };

    const translatePigrecoDetail = (detail) => {
        const normalizedDetail = String(detail || '').trim();
        const lowerDetail = normalizedDetail.toLowerCase();

        if (!normalizedDetail) {
            return '';
        }

        if (lowerDetail.includes('user already present and enrolled in this course')) {
            return 'Utente gia presente e iscritto in questo corso';
        }

        if (lowerDetail.includes('calls per minute limit')) {
            return 'Limite di chiamate al minuto verso Pigreco raggiunto. Riprovare tra poco';
        }

        if (lowerDetail.includes('rate_limit_exceeded')) {
            return 'Limite di chiamate verso Pigreco raggiunto. Riprovare tra poco';
        }

        if (lowerDetail.includes('edition_not_found')) {
            return 'Edizione Pigreco non trovata';
        }

        if (lowerDetail.includes('invalid_request')) {
            return 'Richiesta non valida verso Pigreco';
        }

        if (lowerDetail.includes('subscribe_error')) {
            return 'Errore durante l\'iscrizione su Pigreco';
        }

        return normalizedDetail;
    };

    const formatPigrecoErrorMessage = (error, fallbackMessage) => {
        const payload = error?.response?.data;
        if (!payload) {
            return fallbackMessage;
        }

        if (
            payload.code === 'PIGRECO_INVALID_WORKERS' &&
            Array.isArray(payload.invalidWorkers) &&
            payload.invalidWorkers.length > 0
        ) {
            const details = payload.invalidWorkers
                .slice(0, 3)
                .map((worker) => {
                    const nominativo = [worker.cognome, worker.nome]
                        .filter(Boolean)
                        .join(' ')
                        .trim();
                    const errors = Array.isArray(worker.errors)
                        ? worker.errors.join(', ')
                        : 'dati non validi';
                    return nominativo
                        ? `${nominativo}: ${errors}`
                        : errors;
                })
                .join(' | ');

            return payload.invalidWorkers.length > 3
                ? `${payload.message}. ${details} | ...`
                : `${payload.message}. ${details}`;
        }

        if (payload.code === 'PIGRECO_SUBSCRIBE_FAILED') {
            const worker = payload.worker || {};
            const nominativo = [worker.cognome, worker.nome]
                .filter(Boolean)
                .join(' ')
                .trim();
            const pigrecoRawDetail =
                payload.pigreco?.error_description ||
                payload.pigreco?.error ||
                payload.message;
            const pigrecoDetail = translatePigrecoDetail(pigrecoRawDetail);

            return nominativo
                ? `${nominativo}: ${pigrecoDetail}`
                : pigrecoDetail || fallbackMessage;
        }

        if (payload.code === 'PIGRECO_SUBSCRIBE_CONFLICT') {
            const worker = payload.worker || {};
            const conflictingEditionUser = payload.conflictingEditionUser || {};
            const nominativo = [worker.cognome, worker.nome]
                .filter(Boolean)
                .join(' ')
                .trim();
            const conflictingName = [
                conflictingEditionUser.surname,
                conflictingEditionUser.name,
            ]
                .filter(Boolean)
                .join(' ')
                .trim();
            const conflictingEmail = conflictingEditionUser.email || null;
            const details = [conflictingName, conflictingEmail]
                .filter(Boolean)
                .join(' - ');

            if (nominativo && details) {
                return `${nominativo}: ${payload.message} Conflitto con ${details}.`;
            }

            return payload.message || fallbackMessage;
        }

        return translatePigrecoDetail(payload.message) || fallbackMessage;
    };

    const handleCreateFollowupEdition = async () => {
        if (creatingFollowupEdition) {
            return;
        }
        setCreatingFollowupEdition(true);
        try {
            const response = await unsplash.post(
                'pigreco/createFollowupCourseEdition',
                {
                    corsoHId: props.idCorso,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );
            if (!response?.data?.corsoH?.ID) {
                throw new Error('Nuova aula non creata');
            }

            await props.onFollowupCreated?.(response.data);
            setPigrecoEditionWarning(null);
            setLavoratoriPartecipanti([]);
            setLavoratoriDaAggiungere([]);
            setLavoratoriDaEliminare([]);
            setParticipantSelectionModel([]);
            props.setSnack({
                severity: 'success',
                messaggio: `Nuova aula e-learning creata con edizione Pigreco ${response.data.newEditionId}`,
            });
            props.setOpenSnack(true);
            handleClose();
        } catch (error) {
            console.error('Errore creazione nuova aula e-learning:', error);
            props.setSnack({
                severity: 'error',
                messaggio:
                    error?.response?.data?.message ||
                    error?.message ||
                    'Errore durante la creazione della nuova aula e-learning',
            });
            props.setOpenSnack(true);
        } finally {
            setCreatingFollowupEdition(false);
        }
    };

    const handleOpenExistingFollowupCourse = async () => {
        if (!existingValidFollowupCourse?.ID) {
            return;
        }

        await props.onFollowupCreated?.({
            corsoH: existingValidFollowupCourse,
        });
        setPigrecoEditionWarning(null);
        setExistingValidFollowupCourse(null);
        setLavoratoriPartecipanti([]);
        setLavoratoriDaAggiungere([]);
        setLavoratoriDaEliminare([]);
        setParticipantSelectionModel([]);
        handleClose();
    };

    const handleMigrateIncompleteParticipants = async () => {
        if (!migrationTargetId || migratingParticipants) {
            return;
        }
        const presenceIds = migrationPresenceIds.map(Number).filter(Boolean);
        if (!presenceIds.length) {
            props.setSnack({
                severity: 'warning',
                messaggio: 'Non risultano partecipanti incompleti da migrare',
            });
            props.setOpenSnack(true);
            setMigrationDialogOpen(false);
            setMigrationPresenceIds([]);
            return;
        }
        if (
            !window.confirm(
                `Confermi la migrazione di ${presenceIds.length} partecipanti verso l’edizione PiGreco ${
                    migrationTargets.find(
                        (target) => Number(target.ID) === Number(migrationTargetId)
                    )?.IdEdizionePigreco || migrationTargetId
                }? I partecipanti migrati verranno rimossi dalla vecchia aula.`
            )
        ) {
            return;
        }
        setMigratingParticipants(true);
        try {
            const response = await unsplash.post(
                'pigreco/migrateParticipantsToEdition',
                {
                    sourceCourseHId: props.idCorso,
                    targetCourseHId: Number(migrationTargetId),
                    presenceIds,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );
            const failed = response?.data?.failedWorkers?.length || 0;
            const emailWarnings =
                response?.data?.emailSyncWarnings?.length || 0;
            const supportNotification =
                response?.data?.supportNotification || null;
            setMigrationPresenceIds(
                (response?.data?.retainedSourcePresenceIds || [])
                    .map(Number)
                    .filter(Boolean)
            );
            if (props.handleLoadPresenze) {
                await props.handleLoadPresenze(props.corsiR, props.idCorso);
            }
            props.setSnack({
                severity: failed || emailWarnings ? 'warning' : 'success',
                ...(emailWarnings
                    ? { autoHideDuration: 20000 }
                    : {}),
                messaggio: failed
                    ? `Migrazione completata parzialmente: ${response.data.subscribed} iscritti, ${failed} errori.`
                    : emailWarnings
                      ? supportNotification?.sent
                          ? `Migrazione completata, ma PiGreco non ha confermato ${emailWarnings} email aggiornate. La richiesta di correzione manuale è stata inviata a ${supportNotification.recipient}.`
                          : `Migrazione completata, ma PiGreco non ha confermato ${emailWarnings} email aggiornate. Non è stato possibile avvisare il supporto: effettuare la segnalazione manualmente.`
                      : `Migrazione completata: ${response.data.requested} partecipanti trasferiti nella nuova edizione.`,
            });
            props.setOpenSnack(true);
        } catch (error) {
            props.setSnack({
                severity: 'error',
                messaggio:
                    error?.response?.data?.message ||
                    'Errore durante la migrazione dei partecipanti',
            });
            props.setOpenSnack(true);
        } finally {
            setMigratingParticipants(false);
        }
    };

    const handleSaveMovement = async () => {
        if (savingMovement) {
            return;
        }
        if (isPigrecoEditionBlocked && lavoratoriDaAggiungere.length > 0) {
            props.setSnack({
                severity: 'warning',
                messaggio:
                    'Edizione Pigreco scaduta o conclusa: impossibile aggiungere nuovi partecipanti.',
            });
            props.setOpenSnack(true);
            return;
        }
        setSavingMovement(true);
        try {
            const savedAddedParticipantIds = lavoratoriDaAggiungere
                .map((row) => Number(getWorkerId(row)))
                .filter(Boolean);
            const lavoratoriBloccatiRimozione = lavoratoriDaEliminare.filter(
                hasStartedOnPigreco
            );
            if (lavoratoriBloccatiRimozione.length > 0) {
                const nominativi = lavoratoriBloccatiRimozione
                    .slice(0, 3)
                    .map((el) => `${el.Cognome} ${el.Nome}`.trim())
                    .join(', ');
                props.setSnack({
                    severity: 'warning',
                    messaggio:
                        lavoratoriBloccatiRimozione.length > 3
                            ? `Impossibile rimuovere alcuni partecipanti: hanno gia iniziato il corso su Pigreco (${nominativi}, ...).`
                            : `Impossibile rimuovere alcuni partecipanti: hanno gia iniziato il corso su Pigreco (${nominativi}).`,
                });
                props.setOpenSnack(true);
                return;
            }

            let pigrecoDeleteSkipped = false;
            if (lavoratoriDaAggiungere.length > 0) {
                let daAggiungere = lavoratoriDaAggiungere.map((el) => [
                    props.corsiR[0].ID,
                    getWorkerId(el),
                    0,
                    0,
                ]);

                await unsplash.post(
                    'dettaglioCorsi',
                    {
                        corsiPresenze: daAggiungere,
                        lavoratoriSelezionati: lavoratoriDaAggiungere,
                        modalita: props.modalita,
                        edizione: props.edizione,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    }
                );
            }

            if (lavoratoriDaEliminare.length > 0) {
                let id_da_rimuovere = lavoratoriDaEliminare.map(
                    (el) => el.Lavoratore
                );
                let corsi_r_da_rimuovere = props.corsiR.map((el) => el.ID);
                if (props.modalita === 2) {
                    let iscrizioni_pigreco = lavoratoriDaEliminare
                        .filter((el) => el.IDIscrizionePiGreco)
                        .map((el) => el.IDIscrizionePiGreco);
                    if (iscrizioni_pigreco.length > 0) {
                        await unsplash.post(
                            'pigreco/deleteFromEdition',
                            {
                                lavoratori: iscrizioni_pigreco,
                                corsi_r: corsi_r_da_rimuovere,
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                                },
                            }
                        );
                        setLavoratoriDaEliminare((current) =>
                            clearPigrecoIdsFromRows(
                                current,
                                iscrizioni_pigreco
                            )
                        );
                        setLavoratoriPartecipanti((current) =>
                            clearPigrecoIdsFromRows(
                                current,
                                iscrizioni_pigreco
                            )
                        );
                    } else {
                        pigrecoDeleteSkipped = true;
                        console.warn(
                            'Pigreco delete skipped: nessuna iscrizione da eliminare',
                            { lavoratori: id_da_rimuovere }
                        );
                    }
                }

                await unsplash.delete('dettaglioCorsi', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                    data: {
                        id: id_da_rimuovere,
                        corsi_r: corsi_r_da_rimuovere,
                    },
                });
            }

            await props.handleLoadRighe(props.idCorso);
            props.setSnack({
                severity: 'success',
                messaggio: pigrecoDeleteSkipped
                    ? 'Modifiche salvate con successo (Pigreco: nessuna iscrizione da eliminare)'
                    : 'Modifiche salvate con successo',
            });
            props.setOpenSnack(true);

            // Reset degli stati temporanei
            await props.handleLoadPresenze(props.corsiR, props.idCorso);
            setParticipantSelectionModel((current) =>
                Array.from(
                    new Set([
                        ...current.map(Number).filter(Boolean),
                        ...savedAddedParticipantIds,
                    ])
                )
            );
            setLavoratoriDaAggiungere([]);
            setLavoratoriDaEliminare([]);
        } catch (error) {
            console.error('Errore durante il salvataggio:', error);
            props.setSnack({
                severity: 'error',
                messaggio: formatPigrecoErrorMessage(
                    error,
                    'Errore durante il salvataggio'
                ),
            });
            props.setOpenSnack(true);
        } finally {
            setSavingMovement(false);
        }
    };

    // Questo metodo fa il subscribe del lavoratore al corso e invia la mail solo a quelli
    // nuovi aggiunti.
    const handleSendMail = async () => {
        if (isPigrecoEditionBlocked) {
            props.setSnack({
                severity: 'warning',
                messaggio:
                    'Edizione Pigreco scaduta o conclusa: impossibile iscrivere nuovi partecipanti.',
            });
            props.setOpenSnack(true);
            return;
        }

        // Check se ci sono lavoratori che sono stati aggiunti ma non salvati a db.
        // In questo caso, occorre prima salvare i lavoratori a db e poi iscriverli al corso
        const stillToAdd = getDifference(
            lavoratoriDaAggiungere,
            props.partecipanti,
            'ID',
            'Lavoratore'
        );

        if (stillToAdd.length > 0) {
            props.setSnack({
                severity: 'warning',
                messaggio:
                    'Lavoratori aggiunti ma non salvati. Clicca su salva per rendere effettive le modifiche',
            });
            props.setOpenSnack(true);
            return;
        }

        try {
            if (
                window.confirm(
                    'Sei sicuro di voler inviare la mail? Attenzione, verrà inviata soltanto a chi non ha già ricevuto la mail.'
                )
            ) {
                const freshPresenze = props.handleLoadPresenze
                    ? await props.handleLoadPresenze(
                          props.corsiR,
                          props.idCorso
                      )
                    : null;
                const freshPartecipanti = Array.isArray(freshPresenze?.[0])
                    ? freshPresenze[0]
                    : props.partecipanti;

                let partecipanti_no_pigreco = freshPartecipanti.filter((el) => {
                    const presenzaId = Number(el?.ID);
                    const lavoratoreId = Number(getWorkerId(el));

                    return (
                        selectedPartecipantiIdSet.has(presenzaId) ||
                        selectedPartecipantiIdSet.has(lavoratoreId)
                    );
                });
                partecipanti_no_pigreco = partecipanti_no_pigreco.filter(
                    (el) => !el.IDIscrizionePiGreco
                );
                if (partecipanti_no_pigreco.length === 0) {
                    props.setSnack({
                        severity: 'warning',
                        messaggio:
                            'Seleziona almeno un partecipante non ancora allineato a Pigreco',
                    });
                    props.setOpenSnack(true);
                    return;
                }
                const response = await unsplash.post(
                    'pigreco/subscribeToEdition',
                    {
                        lavoratoriSelezionati: partecipanti_no_pigreco,
                        modalita: props.modalita,
                        edizione: props.edizione,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    }
                );

                const failedWorkers = Array.isArray(
                    response?.data?.failedWorkers
                )
                    ? response.data.failedWorkers
                    : [];
                const emailSyncWarnings = Array.isArray(
                    response?.data?.emailSyncWarnings
                )
                    ? response.data.emailSyncWarnings
                    : [];
                const failedSelectionIds = failedWorkers
                    .map((item) =>
                        Number(
                            item?.worker?.corsoPresenzaId ||
                                item?.worker?.lavoratoreId
                        )
                    )
                    .filter(Boolean);
                const retrySelectionIds = emailSyncWarnings
                    .filter((item) => item?.retryEligible)
                    .map((item) =>
                        Number(
                            item?.worker?.corsoPresenzaId ||
                                item?.worker?.lavoratoreId
                        )
                    )
                    .filter(Boolean);
                const subscribedCount = Number(
                    response?.data?.subscribedCount ?? 0
                );

                await props.handleLoadRighe(props.idCorso);
                if (props.handleLoadPresenze) {
                    await props.handleLoadPresenze(props.corsiR, props.idCorso);
                }
                setParticipantSelectionModel(
                    Array.from(
                        new Set([
                            ...failedSelectionIds,
                            ...retrySelectionIds,
                        ])
                    )
                );
                if (failedWorkers.length > 0) {
                    const details = failedWorkers
                        .slice(0, 2)
                        .map((item) => {
                            const nominativo = [
                                item?.worker?.cognome,
                                item?.worker?.nome,
                            ]
                                .filter(Boolean)
                                .join(' ')
                                .trim();
                            return nominativo
                                ? `${nominativo}: ${item.message}`
                                : item.message;
                        })
                        .join(' | ');

                    props.setSnack({
                        severity: subscribedCount > 0 ? 'warning' : 'error',
                        messaggio:
                            failedWorkers.length > 2
                                ? `Invio completato parzialmente. Iscritti/allineati ${subscribedCount} partecipanti. ${details} | ...`
                                : `Invio completato parzialmente. Iscritti/allineati ${subscribedCount} partecipanti. ${details}`,
                    });
                } else if (emailSyncWarnings.length > 0) {
                    const supportNotification =
                        response?.data?.supportNotification || null;
                    const retryMessage =
                        retrySelectionIds.length === 1
                            ? 'La persona è di nuovo iscrivibile.'
                            : retrySelectionIds.length > 1
                              ? `${retrySelectionIds.length} persone sono di nuovo iscrivibili.`
                              : 'Non è stato possibile rendere nuovamente iscrivibili le persone coinvolte.';
                    const names = emailSyncWarnings
                        .slice(0, 3)
                        .map((item) =>
                            [
                                item?.worker?.cognome,
                                item?.worker?.nome,
                            ]
                                .filter(Boolean)
                                .join(' ')
                        )
                        .filter(Boolean)
                        .join(', ');
                    props.setSnack({
                        severity: 'warning',
                        autoHideDuration: 20000,
                        messaggio: supportNotification?.sent
                            ? `PiGreco non ha confermato l’email aggiornata per ${emailSyncWarnings.length} partecipante/i${names ? `: ${names}` : ''}. La richiesta è stata inviata a ${supportNotification.recipient}. ${retryMessage}`
                            : `PiGreco non ha confermato l’email aggiornata per ${emailSyncWarnings.length} partecipante/i${names ? `: ${names}` : ''}. Non è stato possibile avvisare il supporto. ${retryMessage}`,
                    });
                } else {
                    props.setSnack({
                        severity: 'success',
                        messaggio: 'Email inviate con successo',
                    });
                }
                props.setOpenSnack(true);
            }
        } catch (e) {
            console.error('Errore durante il salvataggio:', e);
            props.setSnack({
                severity: 'error',
                messaggio: formatPigrecoErrorMessage(
                    e,
                    "Errore durante l'invio delle mail"
                ),
            });
            props.setOpenSnack(true);
        }
    };

    const handleSpostaLavoratori = () => {
        if (isPigrecoEditionBlocked) {
            props.setSnack({
                severity: 'warning',
                messaggio:
                    'Edizione Pigreco scaduta o conclusa: impossibile aggiungere nuovi partecipanti.',
            });
            props.setOpenSnack(true);
            return;
        }

        let utentiNoMail = lavoratoriSelezionati.filter((el) => !el.Email);
        if (props.modalita === 2 && utentiNoMail.length > 0) {
            let errMsg =
                "Attenzione, i seguenti lavoratori non hanno un'email associata:\n";
            errMsg += utentiNoMail
                .map((el) => `${el.Cognome} ${el.Nome}`)
                .join(' - ');

            props.setSnack({ severity: 'error', messaggio: errMsg });
            props.setOpenSnack(true);
            return;
        }

        let nuoviPartecipanti = [
            ...lavoratoriPartecipanti,
            ...lavoratoriSelezionati,
        ];
        const nuoviIdsPrioritari = lavoratoriSelezionati
            .map((el) => Number(getWorkerId(el)))
            .filter(Boolean);
        const nextRecentAddedParticipantIds = [
            ...nuoviIdsPrioritari,
            ...recentAddedParticipantIds.filter(
                (id) => !nuoviIdsPrioritari.includes(Number(id))
            ),
        ];
        setRecentAddedParticipantIds(nextRecentAddedParticipantIds);
        setLavoratoriPartecipanti(
            prioritizeRecentParticipants(
                nuoviPartecipanti,
                nextRecentAddedParticipantIds
            )
        );
        postiRimanenti.current = props.postiTot - nuoviPartecipanti.length;

        let nuoviLavoratoriDisponibili = getDifference(
            lavoratori,
            nuoviPartecipanti,
            'ID',
            'ID'
        );
        setLavoratori(nuoviLavoratoriDisponibili);

        // Rimuovo i lavoratori dalla lista delle eliminazioni (se erano stati rimossi prima)
        setLavoratoriDaEliminare(
            lavoratoriDaEliminare.filter(
                (el) => !lavoratoriSelezionati.includes(el)
            )
        );

        // Aggiungo solo chi non era già presente prima del salvataggio
        let nuoviDaAggiungere = lavoratoriSelezionati.filter(
            (el) =>
                !props.partecipanti.some(
                    (p) => p.Lavoratore === getWorkerId(el)
                )
        );
        setLavoratoriDaAggiungere([
            ...lavoratoriDaAggiungere,
            ...nuoviDaAggiungere,
        ]);
    };

    const handleRemoveLavoratori = () => {
        const lavoratoriBloccatiRimozione = lavoratoriDaRimuovere.filter(
            hasStartedOnPigreco
        );
        const lavoratoriConsentitiRimozione = lavoratoriDaRimuovere.filter(
            (el) => !hasStartedOnPigreco(el)
        );

        if (lavoratoriBloccatiRimozione.length > 0) {
            const nominativi = lavoratoriBloccatiRimozione
                .slice(0, 3)
                .map((el) => `${el.Cognome} ${el.Nome}`.trim())
                .join(', ');
            props.setSnack({
                severity: 'warning',
                messaggio:
                    lavoratoriBloccatiRimozione.length > 3
                        ? `I partecipanti ${nominativi}, ... non possono essere rimossi: hanno gia iniziato il corso su Pigreco.`
                        : `I partecipanti ${nominativi} non possono essere rimossi: hanno gia iniziato il corso su Pigreco.`,
            });
            props.setOpenSnack(true);
        }

        if (lavoratoriConsentitiRimozione.length === 0) {
            return;
        }

        let nuoviLavoratoriDisponibili = [
            ...lavoratori,
            ...lavoratoriConsentitiRimozione,
        ];
        setLavoratori(nuoviLavoratoriDisponibili);

        let nuoviPartecipanti = getDifference(
            lavoratoriPartecipanti,
            lavoratoriConsentitiRimozione,
            'ID',
            'ID'
        );
        const lavoratoriRimossiIds = lavoratoriConsentitiRimozione
            .map((el) => Number(getWorkerId(el)))
            .filter(Boolean);
        const nextRecentAddedParticipantIds = recentAddedParticipantIds.filter(
            (id) => !lavoratoriRimossiIds.includes(Number(id))
        );
        setRecentAddedParticipantIds(nextRecentAddedParticipantIds);
        setLavoratoriPartecipanti(
            prioritizeRecentParticipants(
                nuoviPartecipanti,
                nextRecentAddedParticipantIds
            )
        );
        postiRimanenti.current = props.postiTot - nuoviPartecipanti.length;

        // Rimuovo i lavoratori dalla lista delle aggiunte (se erano stati aggiunti prima)
        setLavoratoriDaAggiungere(
            lavoratoriDaAggiungere.filter(
                (el) => !lavoratoriConsentitiRimozione.includes(el)
            )
        );

        // Aggiungo solo chi era già iscritto prima
        let nuoviDaEliminare = lavoratoriConsentitiRimozione.filter((el) =>
            props.partecipanti.some(
                (p) => p.Lavoratore === (el.Lavoratore ?? el.ID)
            )
        );
        setLavoratoriDaEliminare([
            ...lavoratoriDaEliminare,
            ...nuoviDaEliminare,
        ]);
    };

    function CustomToolbar(title) {
        return (
            <>
                <GridToolbarContainer>
                    <Typography
                        component="span"
                        variant="subtitle1"
                        sx={{ textAlign: 'center', width: '100%' }}
                    >
                        {title}{' '}
                    </Typography>

                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        <GridToolbarQuickFilter placeholder="Cerca..." />
                    </Grid>
                </GridToolbarContainer>
            </>
        );
    }

    return (
        <>
            <Button
                startIcon={<GroupsIcon />}
                className="ButtonMiller"
                variant="contained"
                onClick={props.loading ? undefined : handleClickOpen}
            >
                Gestione Partecipanti
                <i>
                    {props.postiTot > 0 &&
                        `${props.postiRim}/${props.postiTot}`}
                </i>
                {props.loading && (
                    <CircularProgress
                        color="inherit"
                        size={20}
                        sx={{ ml: 1 }}
                    />
                )}
            </Button>

            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="xl"
                TransitionComponent={Transition}
            >
                <DialogTitle sx={{ mx: 'auto' }} id="alert-dialog-title">
                    <Typography component="span" variant="h6">
                        Gestione Partecipanti
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={12}
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginBottom: '5px',
                            }}
                        >
                            <Typography component="span" variant="subtitle1">
                                {props.modalita !== 2
                                    ? `Posti rimanenti: ${postiRimanenti.current}/${props.postiTot}`
                                    : ''}
                            </Typography>
                        </Grid>
                        {pigrecoEditionWarning && (
                            <Grid item xs={12}>
                                <Alert
                                    severity="warning"
                                    action={
                                        existingValidFollowupCourse ? (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="medium"
                                                onClick={
                                                    handleOpenExistingFollowupCourse
                                                }
                                                endIcon={<ArrowForward />}
                                                sx={{
                                                    color: '#fff',
                                                    fontWeight: 700,
                                                    whiteSpace: 'nowrap',
                                                    ml: 2,
                                                }}
                                            >
                                                Apri aula esistente
                                            </Button>
                                        ) : (
                                            <Button
                                                variant="contained"
                                                color="error"
                                                size="medium"
                                                onClick={
                                                    handleCreateFollowupEdition
                                                }
                                                disabled={
                                                    creatingFollowupEdition
                                                }
                                                startIcon={
                                                    creatingFollowupEdition ? (
                                                        <CircularProgress
                                                            color="inherit"
                                                            size={16}
                                                        />
                                                    ) : (
                                                        <Add />
                                                    )
                                                }
                                                sx={{
                                                    color: '#fff',
                                                    fontWeight: 700,
                                                    whiteSpace: 'nowrap',
                                                    ml: 2,
                                                }}
                                            >
                                                {creatingFollowupEdition
                                                    ? 'Creazione...'
                                                    : 'Crea nuova aula'}
                                            </Button>
                                        )
                                    }
                                >
                                    {pigrecoEditionWarning} L'aggiunta di nuovi
                                    partecipanti e l'invio email sono
                                    disabilitati su questa aula.
                                    {existingValidFollowupCourse
                                        ? ` Esiste gia un'altra aula per questo corso: ${existingValidFollowupCourse.NomeEdizione || `ID ${existingValidFollowupCourse.CorsoHID}`}.`
                                        : ''}
                                </Alert>
                            </Grid>
                        )}

                        <Grid item xs={6} style={{ height: '30px' }}>
                            <Grid
                                item
                                xs={12}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    height: '30px',
                                }}
                            >
                                <Button
                                    variant="contained"
                                    className="ButtonMiller"
                                    size="small"
                                    sx={{
                                        display:
                                            lavoratoriSelezionati.length > 0
                                                ? ''
                                                : 'none',
                                    }}
                                    endIcon={<ArrowForward />}
                                    onClick={handleSpostaLavoratori}
                                    disabled={isPigrecoEditionBlocked}
                                >
                                    Sposta
                                </Button>
                            </Grid>
                            <Box
                                sx={{
                                    height: 400,
                                    width: 1,
                                    marginTop: '10px',
                                    textAlign: 'center',
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <DataGridPro
                                    components={{
                                        Toolbar: () =>
                                            CustomToolbar('Disponibili'),
                                        Footer: CustomFooterPersonalized,
                                    }}
                                    componentsProps={{
                                        cell: {
                                            onClick: (event) => {
                                                event.stopPropagation();
                                            },
                                        },
                                        baseCheckbox: {
                                            onClick: (event) => {
                                                event.stopPropagation();
                                            },
                                        },
                                        row: {
                                            onClick: (event) => {
                                                event.stopPropagation();
                                            },
                                        },
                                    }}
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                    }}
                                    loading={loading}
                                    sx={{
                                        fontSize: 12,
                                    }}
                                    localeText={
                                        itIT.components.MuiDataGrid.defaultProps
                                            .localeText
                                    }
                                    rows={lavoratori}
                                    getRowId={(row) => row.ID}
                                    columns={columns}
                                    pageSize={100}
                                    disableRowSelectionOnClick
                                    checkboxSelection
                                    isRowSelectable={() =>
                                        !isPigrecoEditionBlocked
                                    }
                                    onSelectionModelChange={(ids) => {
                                        if (isPigrecoEditionBlocked) {
                                            setLavoratoriSelezionati([]);
                                            return;
                                        }
                                        const selectedIDs = new Set(ids);
                                        const selectedRowData =
                                            lavoratori.filter((row) =>
                                                selectedIDs.has(row.ID)
                                            );
                                        setLavoratoriSelezionati(
                                            selectedRowData
                                        );
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid
                                item
                                xs={12}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    height: '30px',
                                }}
                            >
                                <Button
                                    variant="contained"
                                    className="ButtonMiller"
                                    size="small"
                                    sx={{
                                        display:
                                            lavoratoriDaRimuovere.length > 0
                                                ? ''
                                                : 'none',
                                    }}
                                    startIcon={<ArrowBack />}
                                    onClick={handleRemoveLavoratori}
                                >
                                    Sposta
                                </Button>
                            </Grid>
                            <Box
                                sx={{
                                    height: 400,
                                    width: 1,
                                    marginTop: '10px',
                                }}
                            >
                                <DataGridPro
                                    components={{
                                        Toolbar: () =>
                                            CustomToolbar('Partecipanti'),
                                        Footer: CustomFooterPersonalized,
                                    }}
                                    componentsProps={{
                                        cell: {
                                            onClick: (event) => {
                                                event.stopPropagation();
                                            },
                                        },
                                        baseCheckbox: {
                                            onClick: (event) => {
                                                event.stopPropagation();
                                            },
                                        },
                                        row: {
                                            onClick: (event) => {
                                                event.stopPropagation();
                                            },
                                        },
                                    }}
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                    }}
                                    loading={loadingPart}
                                    sx={{
                                        fontSize: 12,
                                        '& .row-non-rimovibile': {
                                            backgroundColor: '#f2f2f2',
                                            color: '#808080',
                                        },
                                    }}
                                    localeText={
                                        itIT.components.MuiDataGrid.defaultProps
                                            .localeText
                                    }
                                    rows={lavoratoriPartecipanti}
                                    getRowId={(row) => row.ID}
                                    getRowClassName={(params) =>
                                        hasStartedOnPigreco(params.row)
                                            ? 'row-non-rimovibile'
                                            : ''
                                    }
                                    columns={columns}
                                    pageSize={100}
                                    disableRowSelectionOnClick
                                    checkboxSelection
                                    selectionModel={selectedPartecipantiIds}
                                    isRowSelectable={(params) =>
                                        !hasStartedOnPigreco(params.row)
                                    }
                                    onSelectionModelChange={(ids) => {
                                        const forcedSelection = new Set(
                                            unsavedAddedParticipantIds
                                        );
                                        const normalizedIds = ids.map(Number);
                                        setParticipantSelectionModel(
                                            normalizedIds
                                        );
                                        const selectedIDs = new Set(ids);
                                        const selectedRowData =
                                            lavoratoriPartecipanti.filter(
                                                (row) =>
                                                    selectedIDs.has(row.ID) &&
                                                    !forcedSelection.has(
                                                        Number(
                                                            row.ID ??
                                                                getWorkerId(row)
                                                        )
                                                    )
                                            );

                                        setLavoratoriDaRimuovere(
                                            selectedRowData
                                        );
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    {props.modalita === 2 && migrationTargets.length > 0 && (
                        <Alert
                            severity="info"
                            sx={{ mt: 2 }}
                            action={
                                <Button
                                    variant="contained"
                                    onClick={handleMigrateIncompleteParticipants}
                                    disabled={
                                        !migrationTargetId ||
                                        !migrationPresenceIds.length ||
                                        migratingParticipants
                                    }
                                >
                                    {migratingParticipants
                                        ? 'Migrazione...'
                                        : 'Conferma migrazione'}
                                </Button>
                            }
                        >
                            <FormControl size="small" sx={{ minWidth: 320 }}>
                                <InputLabel id="migration-target-label">
                                    Nuova edizione
                                </InputLabel>
                                <Select
                                    labelId="migration-target-label"
                                    value={migrationTargetId}
                                    label="Nuova edizione"
                                    onChange={(event) =>
                                        setMigrationTargetId(event.target.value)
                                    }
                                >
                                    {migrationTargets.map((target) => (
                                        <MenuItem key={target.ID} value={target.ID}>
                                            {target.NomeEdizione ||
                                                `Aula ${target.ID}`}{' '}
                                            — PiGreco {target.IdEdizionePigreco}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Button
                                sx={{ ml: 1 }}
                                variant="outlined"
                                onClick={() => setMigrationDialogOpen(true)}
                            >
                                Seleziona partecipanti
                            </Button>
                        </Alert>
                    )}
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mt: 2,
                        mx: 2,
                    }}
                >
                    <Button
                        onClick={handleClose}
                        className="ButtonMiller"
                        variant="contained"
                        startIcon={<Close />}
                    >
                        CHIUDI
                    </Button>
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'nowrap',
                            gap: '5px',
                        }}
                    >
                        <DialogGestioneClientiFatturazione
                            clienti={props.clienti}
                            ModalitaFatturazioneCorsi={
                                props.ModalitaFatturazioneCorsi
                            }
                            idCorso={props.idCorso}
                            snack={props.snack}
                            openSnack={props.openSnack}
                            handleCloseSnack={props.handleCloseSnack}
                            setSnack={props.setSnack}
                            setOpenSnack={props.setOpenSnack}
                        />
                        <Button
                            onClick={handleSaveMovement}
                            className="ButtonMiller"
                            variant="contained"
                            startIcon={
                                savingMovement ? (
                                    <CircularProgress
                                        color="inherit"
                                        size={15}
                                    />
                                ) : (
                                    <Check />
                                )
                            }
                            disabled={savingMovement}
                        >
                            Salva
                        </Button>
                        {props.modalita === 2 && (
                            <Button
                                onClick={handleSendMail}
                                className="ButtonMiller"
                                variant="contained"
                                startIcon={<Send />}
                                disabled={isPigrecoEditionBlocked}
                            >
                                Invia Email
                            </Button>
                        )}
                    </div>
                </DialogActions>
            </Dialog>
            <Dialog
                open={migrationDialogOpen}
                onClose={() => setMigrationDialogOpen(false)}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>Partecipanti incompleti da migrare</DialogTitle>
                <DialogContent>
                    <Box sx={{ height: 500, mt: 1 }}>
                        <DataGridPro
                            components={{
                                Toolbar: () =>
                                    CustomToolbar('Partecipanti incompleti'),
                            }}
                            rows={migrationEligibleParticipants}
                            getRowId={(row) => row.IDCorsoPresenza}
                            columns={columns}
                            pageSize={100}
                            checkboxSelection
                            disableRowSelectionOnClick
                            selectionModel={migrationPresenceIds}
                            onSelectionModelChange={(ids) => {
                                if (ids.length > 100) {
                                    props.setSnack({
                                        severity: 'warning',
                                        messaggio:
                                            'Puoi migrare al massimo 100 partecipanti alla volta',
                                    });
                                    props.setOpenSnack(true);
                                    return;
                                }
                                setMigrationPresenceIds(ids.map(Number));
                            }}
                            localeText={
                                itIT.components.MuiDataGrid.defaultProps
                                    .localeText
                            }
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setMigrationDialogOpen(false)}>
                        Annulla
                    </Button>
                    <Button
                        variant="contained"
                        disabled={!migrationPresenceIds.length}
                        onClick={() => setMigrationDialogOpen(false)}
                    >
                        Usa selezionati ({migrationPresenceIds.length})
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const DialogGestioneDateCorsi = (props) => {
    const [open, setOpen] = useState(false);
    const [giorno, setGiorno] = useState(null);
    const [orario, setOrario] = useState(null);
    const [durata, setDurata] = useState('');

    const handleClickOpen = async () => {
        if (props.operation === 'Nuovo') {
            setGiorno(null);
            setOrario(null);
            setDurata(null);
            setOpen(true);
        } else {
            if (!props.giornoSel) {
                props.setSnack({
                    severity: 'error',
                    messaggio: 'Seleziona almeno un giorno',
                });
                props.setOpenSnack(true);
                return;
            }
            setGiorno(moment(props.giornoSel[0].Data));
            setOrario(moment(new Date('2022-09-02 ' + props.giornoSel[0].Ora)));
            setDurata(props.giornoSel[0].Durata);

            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = async () => {
        try {
            if (props.operation === 'Nuovo') {
                let corsoRiga = {
                    Corso: props.idCorso,
                    Formatore: props.formatore,
                    Data: moment(giorno).format('YYYY-MM-DD'),
                    Ora: orario.format('HH:mm:ss'),
                    Durata: durata,
                };
                if (giorno === null) {
                    props.setSnack({
                        severity: 'error',
                        messaggio: 'Inserisci il giorno del corso',
                    });
                    props.setOpenSnack(true);
                } else if (orario === null) {
                    props.setSnack({
                        severity: 'error',
                        messaggio: "Inserisci l'orario del corso",
                    });
                    props.setOpenSnack(true);
                } else {
                    try {
                        await unsplash.post(
                            'corsi',
                            { corso: corsoRiga, tipo: 'R' }, //Creo corso header STEP 1
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                                },
                            }
                        );
                        props.setSnack({
                            severity: 'success',
                            messaggio: 'Corso creato con successo',
                        });
                        props.setOpenSnack(true);
                    } catch {
                        props.setSnack({
                            severity: 'error',
                            messaggio: 'Errore durante la creazione del corso',
                        });
                        props.setOpenSnack(true);
                    }
                }
            } else {
                try {
                    let corsoRiga = {
                        ID: props.giornoSel[0].ID,
                        Corso: props.idCorso,
                        Formatore: props.formatore,
                        Data: moment(giorno).format('YYYY-MM-DD'),
                        Ora: orario.format('HH:mm:ss'),
                        Durata: durata,
                    };
                    await unsplash.put(
                        'corsi',
                        { corso: corsoRiga, tipo: 'R' }, //Creo corso header STEP 1
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                            },
                        }
                    );
                    props.setSnack({
                        severity: 'success',
                        messaggio: 'Corso modificato con successo',
                    });
                    props.setOpenSnack(true);
                } catch {
                    props.setSnack({
                        severity: 'error',
                        messaggio: 'Errore durante la modifica del corso',
                    });
                    props.setOpenSnack(true);
                }
            }

            if (typeof props.handleLoadRighe === 'function') {
                await props.handleLoadRighe(props.idCorso);
            }
            if (typeof props.setEdit === 'function') {
                props.setEdit(true);
            }
        } catch (error) {
            props.setSnack({
                severity: 'error',
                messaggio:
                    "Errore durante l'aggiornamento del corso: " +
                    (error.response?.data?.message || error.message),
            });
            props.setOpenSnack(true);
        }
        setOpen(false);
    };

    return (
        <>
            {/* <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      /> */}
            {props.operation === 'Nuovo' ? (
                <Button
                    startIcon={<Add />}
                    className="ButtonMiller"
                    variant="contained"
                    onClick={handleClickOpen}
                >
                    Aggiungi
                </Button>
            ) : (
                <IconButton aria-label="edit" onClick={handleClickOpen}>
                    <EditIcon
                        style={{
                            height: '2rem',
                            width: '2rem',
                            color: '#2265B1',
                        }}
                    />
                </IconButton>
            )}
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle id="alert-dialog-title" sx={{ mx: 'auto' }}>
                    {props.Title}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <LocalizationProvider dateAdapter={DateAdapter}>
                                <DatePicker
                                    slotProps={{
                                        textField: { fullWidth: true },
                                    }}
                                    ampmInClock={false}
                                    renderInput={(props) => (
                                        <TextField
                                            sx={{ mt: 1 }}
                                            size="small"
                                            fullWidth
                                            {...props}
                                        />
                                    )}
                                    label="Giorno"
                                    value={moment(giorno)}
                                    onChange={(newValue) => {
                                        setGiorno(newValue ? newValue : null);
                                    }}
                                    sx={{ marginTop: '5px' }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12}>
                            <LocalizationProvider dateAdapter={DateAdapter}>
                                <TimePicker
                                    slotProps={{
                                        textField: { fullWidth: true },
                                    }}
                                    ampmInClock={false}
                                    renderInput={(props) => (
                                        <TextField
                                            size="small"
                                            fullWidth
                                            {...props}
                                        />
                                    )}
                                    label="Ora"
                                    value={moment(orario)}
                                    onChange={(newValue) => {
                                        setOrario(newValue ? newValue : null);
                                    }}
                                    sx={{ marginTop: '5px' }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                {...props}
                                label="Durata"
                                type="number"
                                value={durata}
                                onChange={(e) => setDurata(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mx: 2,
                    }}
                >
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Close />}
                        onClick={handleClose}
                    >
                        annulla
                    </Button>
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Check />}
                        onClick={handleSave}
                    >
                        Conferma
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const DialogDeleteData = (props) => {
    const [open, setOpen] = useState(false);

    /* const [openSnack, setOpenSnack] = useState(false);
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };
  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  }); */

    const handleClickOpen = async () => {
        if (!props.giornoSel) {
            props.setSnack({
                severity: 'error',
                messaggio: 'Seleziona almeno un giorno',
            });
            props.setOpenSnack(true);
            return;
        }
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = async () => {
        try {
            const response = await unsplash.delete('corsi', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                data: { corso: props.giornoSel[0].ID, tipo: 'R' },
            });

            if (response?.data?.blocked) {
                props.setSnack({
                    severity: 'warning',
                    messaggio:
                        response.data.message ||
                        "Impossibile eliminare l'aula",
                });
                props.setOpenSnack(true);
                setOpen(false);
                return;
            }

            props.handleLoadRighe(props.idCorso);
            props.setSnack({
                severity: 'success',
                messaggio: 'Giorno corso eliminato con successo',
            });
            props.setOpenSnack(true);
        } catch {
            props.setSnack({
                severity: 'error',
                messaggio: "Errore durante l'eliminazione",
            });
            props.setOpenSnack(true);
        }

        setOpen(false);
    };

    return (
        <>
            {/* <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      /> */}
            <IconButton aria-label="edit" onClick={handleClickOpen}>
                <Delete
                    style={{ height: '2rem', width: '2rem', color: '#FF2768' }}
                />
            </IconButton>
            {/* <Button
        startIcon={<Delete />}
        className="ButtonMillerError"
        variant="contained"
        onClick={handleClickOpen}
      >
        ELIMINA
      </Button> */}

            <Dialog
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Sei sicuro di voler eliminare?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Attenzione, sei sicuro di voler eliminare il giorno
                        selezionato: <br />
                        <b>
                            {moment(props.giornoSel[0]?.Data).format(
                                'YYYY-MM-DD'
                            )}
                        </b>
                        ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mx: 2,
                    }}
                >
                    <Button onClick={handleClose}>annulla</Button>
                    <Button onClick={handleDelete}>Conferma</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const DialogGestioneClientiFatturazione = (props) => {
    const [open, setOpen] = React.useState(false);
    const scroll = 'paper';
    const [clienti, setClienti] = useState([]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (index, event) => {
        let c = [...clienti];

        c[index].ModalitaFatturazione = event.target.value;
        c[index].Edited = 1;
        setClienti(c);
    };

    const handleChangeText = (e, index) => {
        let c = [...clienti];

        c[index].CostoForfait = e.target.value;
        c[index].Edited = 1;
        setClienti(c);
    };

    const handleSave = async () => {
        try {
            await unsplash.post(
                'modalitaFatturazioneCorsi',
                { corso: props.idCorso, modalitaFatturazione: clienti }, //Creo corso header STEP 1
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );

            let response = await unsplash.get('modalitaFatturazioneCorsi', {
                params: { IDCorso: props.idCorso },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            });

            setClienti(response.data.data);
            props.setSnack({
                severity: 'success',
                messaggio: 'Fatturazione aggiornata con successo',
            });
            props.setOpenSnack(true);
        } catch {
            props.setSnack({
                severity: 'error',
                messaggio: "Errore durante l'aggiornamento",
            });
            props.setOpenSnack(true);
        }
        setOpen(false);
    };

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    return (
        <div>
            <GlobalSnackbar
                severity={props.snack.severity}
                messaggio={props.snack.messaggio}
                openSnack={props.openSnack}
                handleCloseSnack={props.handleCloseSnack}
            />
            {/*<Button
        //size="small"
        variant="contained"
        className="ButtonMiller"
        onClick={handleClickOpen("paper")}
      >
        Modalità Fatturazione Corso Aziende
      </Button>*/}
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={scroll}
                maxWidth="lg"
                fullWidth
                TransitionComponent={Transition}
            >
                <DialogTitle id="scroll-dialog-title">
                    Gestisci modalità di pagamento
                </DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                    >
                        <Grid container spacing={2}>
                            {clienti.map((p, index) => (
                                <>
                                    <Grid key={index} item xs={4}>
                                        {p.RagioneSociale}{' '}
                                    </Grid>{' '}
                                    <Grid item xs={4}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">
                                                Modalità
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={p.ModalitaFatturazione}
                                                label="Modalita"
                                                onChange={(e) =>
                                                    handleChange(index, e)
                                                }
                                            >
                                                {props.ModalitaFatturazioneCorsi.map(
                                                    (p) => (
                                                        <MenuItem
                                                            key={p.ID}
                                                            value={p.ID}
                                                        >
                                                            {p.Descrizione}
                                                        </MenuItem>
                                                    )
                                                )}
                                            </Select>
                                        </FormControl>{' '}
                                    </Grid>{' '}
                                    <Grid item xs={4}>
                                        <TextField
                                            sx={{
                                                display:
                                                    p.ModalitaFatturazione === 2
                                                        ? ''
                                                        : 'None',
                                            }}
                                            value={p.CostoForfait}
                                            label="Costo Forfait"
                                            onChange={(e) =>
                                                handleChangeText(e, index)
                                            }
                                        />
                                    </Grid>
                                </>
                            ))}
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mt: 2,
                        px: 2,
                    }}
                >
                    <Button
                        onClick={handleClose}
                        className="ButtonMiller"
                        variant="contained"
                        startIcon={<Close />}
                    >
                        CHIUDI
                    </Button>
                    <Button
                        onClick={handleSave}
                        className="ButtonMiller"
                        variant="contained"
                        startIcon={<Check />}
                    >
                        Salva
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

function getDifference(array1, array2, prop1, prop2) {
    //riutilizzabile per differenze tra due array di oggetti
    return array1.filter((object1) => {
        return !array2.some((object2) => {
            return object1[prop1] === object2[prop2];
        });
    });
}

function mergePartecipanti(lavoratori, partecipanti) {
    const partecipantiUnici = [];
    const seenIds = new Set();
    (partecipanti || []).forEach((item) => {
        const id = item?.Lavoratore ?? item?.ID;
        if (!id || seenIds.has(id)) {
            return;
        }
        seenIds.add(id);
        partecipantiUnici.push(item);
    });

    const byId = new Map(
        (lavoratori || []).map((item) => [item.ID, { ...item }])
    );

    partecipantiUnici.forEach((item) => {
        const id = item.Lavoratore ?? item.ID;
        const corsoPresenzaId =
            item.IDCorsoPresenza ?? (item.Lavoratore ? item.ID : null);
        if (!id) {
            return;
        }
        const existing = byId.get(id) || {};
        const merged = { ...existing, ...item };
        merged.ID = id;
        merged.Lavoratore = id;
        if (corsoPresenzaId) {
            merged.IDCorsoPresenza = corsoPresenzaId;
        }
        if (!merged.Cliente && merged.RagioneSociale) {
            merged.Cliente = merged.RagioneSociale;
        }
        byId.set(id, merged);
    });

    return partecipantiUnici
        .map((item) => byId.get(item.Lavoratore ?? item.ID))
        .filter(Boolean);
}
